(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sg-accessory-entry"]) return;
  try {
    
if (!customElements.get('sg-accessory-groups')) {
  customElements.define('sg-accessory-groups', class extends HTMLElement {
    connectedCallback() {
      this.media = window.matchMedia('(max-width: 749px)');
      this.syncLayout = () => {
        this.querySelectorAll('details').forEach((group) => {
          group.open = !this.media.matches;
          group.querySelector('summary').tabIndex = this.media.matches ? 0 : -1;
        });
      };
      this.keepDesktopOpen = (event) => {
        if (event.target instanceof Element && event.target.closest('summary') && !this.media.matches) event.preventDefault();
      };
      this.addEventListener('click', this.keepDesktopOpen);
      this.media.addEventListener('change', this.syncLayout);
      this.syncLayout();
      this.classList.add('sg-accessory-ready');
    }
    disconnectedCallback() {
      this.removeEventListener('click', this.keepDesktopOpen);
      this.media.removeEventListener('change', this.syncLayout);
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sg-accessory-navigation"]) return;
  try {
    
if (!customElements.get('sg-accessory-navigation')) {
  customElements.define('sg-accessory-navigation', class extends HTMLElement {
    connectedCallback() {
      this.abort?.abort();
      this.abort = new AbortController();
      const signal = this.abort.signal;
      this.schedule = () => { if (!this.frame) this.frame = requestAnimationFrame(() => { this.frame = 0; this.update(); }); };
      this.init = () => {
        this.nav = this.querySelector('nav');
        if (!this.nav) return;
        this.header = document.querySelector('.section-header');
        this.main = document.getElementById('MainContent') || document.querySelector('main');
        this.contentBounds = [];
        this.links = [...this.querySelectorAll('a[data-target]')];
        this.resolve();
        this.nav.addEventListener('click', event => this.jump(event), { signal });
        window.addEventListener('scroll', this.schedule, { passive: true, signal });
        window.addEventListener('resize', this.schedule, { passive: true, signal });
        window.addEventListener('pageshow', this.schedule, { signal });
        document.addEventListener('shopify:section:load', () => { this.resolve(); this.schedule(); }, { signal });
        document.addEventListener('shopify:section:unload', this.schedule, { signal });
        this.resizeObserver = new ResizeObserver(this.schedule);
        if (this.header) this.resizeObserver.observe(this.header);
        if (this.main) this.resizeObserver.observe(this.main);
        this.resizeObserver.observe(this.nav);
        if (this.header) {
          this.headerObserver = new MutationObserver(() => { this.animateUntil = performance.now() + 200; this.schedule(); });
          this.headerObserver.observe(this.header, { attributes: true, attributeFilter: ['class'] });
        }
        this.schedule();
      };
      if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', this.init, { once: true, signal });
      else this.init();
    }
    resolve() {
      const overviewLink = this.links.find(link => link.dataset.kind === 'overview');
      this.productSection = overviewLink ? [...(this.main?.children || [])].find(el => el.id === overviewLink.dataset.target || el.id.endsWith('__' + overviewLink.dataset.target)) : null;
      this.entries = this.links.map(link => {
        let target = document.getElementById(link.dataset.target);
        if (!target) target = [...(this.main?.children || [])].find(el => el.id.endsWith('__' + link.dataset.target));
        if (target && link.dataset.kind === 'overview') target = target.querySelector('h1') || target;
        else if (target && link.dataset.kind === 'reviews') target = target.querySelector('.jdgm-review-widget') || target;
        else if (target) target = target.querySelector('h2, h3') || target;
        link.hidden = !target;
        if (target) {
          if (!target.id) target.id = 'sg-led-' + link.dataset.kind;
          link.href = '#' + target.id;
        }
        return { link, target };
      }).filter(entry => entry.target);
      this.contentBounds = [...new Set(this.entries.filter(entry => entry.link.dataset.kind !== 'overview').map(entry => entry.target.closest('.product__description') || entry.target.closest('.page-width') || entry.target.closest('.shopify-section')).filter(element => element && element !== this.productSection))];
      for (const element of this.main.querySelectorAll('.page-width')) {
        if (!this.productSection?.contains(element) && !element.querySelector('.page-width') && !this.contentBounds.includes(element)) this.contentBounds.push(element);
      }
      for (const section of this.main.children) {
        if (section !== this.productSection && !section.contains(this) && section.querySelector('h2, h3') && !section.querySelector('.page-width') && !section.classList.contains('page-width') && !this.contentBounds.includes(section)) this.contentBounds.push(section);
      }
      for (const element of this.contentBounds) {
        if (!element.classList.contains('sg-section-nav-content')) element.style.setProperty('--sg-section-nav-padding', getComputedStyle(element).paddingLeft);
        element.classList.add('sg-section-nav-content');
      }
    }
    update() {
      if (!this.nav || !this.isConnected) return;
      const rect = this.header?.getBoundingClientRect();
      const offset = rect ? Math.max(0, Math.min(rect.bottom, rect.height)) : 0;
      this.style.setProperty('--sg-led-nav-top', Math.round(offset) + 'px');
      const side = innerWidth >= 990 && innerHeight >= 600;
      for (const element of this.contentBounds) {
        const inset = Math.max(0, 176 - element.getBoundingClientRect().left) + 'px';
        if (side && element.style.getPropertyValue('--sg-section-nav-inset') !== inset) element.style.setProperty('--sg-section-nav-inset', inset);
        else if (!side) element.style.removeProperty('--sg-section-nav-inset');
      }
      const contentLeft = 176;
      this.toggleAttribute('data-side', side);
      if (side) this.style.setProperty('--sg-led-nav-left', Math.floor(contentLeft - 148) + 'px');
      const usable = this.entries.filter(entry => entry.target.isConnected && entry.target.getClientRects().length && entry.target.getBoundingClientRect().height > 0);
      for (const entry of this.entries) entry.link.hidden = !usable.includes(entry);
      const contentStart = Math.min(...usable.filter(entry => entry.link.dataset.kind !== 'overview').map(entry => entry.target.getBoundingClientRect().top));
      const revealEdge = offset + (side ? 0 : this.nav.offsetHeight) + 24;
      const productPassed = contentStart <= revealEdge || (this.productSection && this.productSection.getBoundingClientRect().bottom <= revealEdge);
      const visible = window.scrollY > Number(this.dataset.reveal || 500) && productPassed && usable.length > 1;
      this.toggleAttribute('data-visible', visible);
      this.nav.inert = !visible;
      const threshold = offset + (side ? 0 : this.nav.offsetHeight) + 24;
      let current = usable[0];
      for (const entry of usable) if (entry.target.getBoundingClientRect().top <= threshold) current = entry;
      for (const entry of usable) {
        if (entry === current) entry.link.setAttribute('aria-current', 'location');
        else entry.link.removeAttribute('aria-current');
      }
      if (current && current !== this.current && visible && !side) {
        const row = this.querySelector('.sg-accessory-navigation__links');
        if (!this.nav.contains(document.activeElement)) {
          const a = current.link.getBoundingClientRect();
          const r = row.getBoundingClientRect();
          if (a.left < r.left || a.right > r.right) row.scrollBy({ left: a.left - r.left - 12, behavior: 'instant' });
        }
      }
      this.current = current;
      if (performance.now() < (this.animateUntil || 0)) this.schedule();
    }
    jump(event) {
      const link = event.target.closest('a[data-target]');
      if (!link || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.button !== 0) return;
      const entry = this.entries.find(item => item.link === link);
      if (!entry?.target.isConnected) return;
      event.preventDefault();
      const headerRect = this.header?.getBoundingClientRect();
      const headerHeight = headerRect ? Math.max(0, Math.min(headerRect.bottom, headerRect.height)) : 0;
      const offset = headerHeight + (this.hasAttribute('data-side') ? 0 : this.nav.offsetHeight) + 16;
      entry.target.setAttribute('tabindex', '-1');
      entry.target.focus({ preventScroll: true });
      window.scrollTo({ top: Math.max(0, window.scrollY + entry.target.getBoundingClientRect().top - offset), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
    }
    disconnectedCallback() {
      for (const element of this.contentBounds || []) {
        element.classList.remove('sg-section-nav-content');
        element.style.removeProperty('--sg-section-nav-padding');
        element.style.removeProperty('--sg-section-nav-inset');
      }
      this.abort?.abort();
      this.resizeObserver?.disconnect();
      this.headerObserver?.disconnect();
      cancelAnimationFrame(this.frame);
      this.frame = 0;
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sg-brand-accessories"]) return;
  try {
    
  if (!customElements.get('sg-brand-accessories')) {
    customElements.define('sg-brand-accessories', class extends HTMLElement {
      connectedCallback() {
        if (this.ready) return;
        this.ready = true;
        this.cards = Array.from(this.querySelectorAll('[data-product-id]'));
        // Only enhance when every collection item is present; never filter a partial page.
        if (this.dataset.complete !== 'true' || this.cards.length !== Number(this.dataset.total)) return;
        this.buttons = Array.from(this.querySelectorAll('[data-filter]'));
        this.grid = this.querySelector('.sg-brand-accessories__grid');
        this.count = this.querySelector('[data-visible-count]');
        this.sort = this.querySelector('[data-sort]');
        this.buttons.forEach(button => {
          const count = this.cards.filter(card => button.dataset.filter === 'alle' || card.dataset.group === button.dataset.filter).length;
          button.querySelector('[data-count]').textContent = '(' + count + ')';
          button.hidden = count === 0 && button.dataset.filter !== 'alle';
        });
        this.onClick = event => {
          const button = event.target.closest('button[data-filter]');
          if (!button || !this.contains(button)) return;
          const url = new URL(window.location.href);
          url.hash = button.dataset.filter === 'alle' ? '' : 'zubehoer-' + button.dataset.filter;
          history.pushState(null, '', url);
          this.applyFilter();
        };
        this.onHistory = () => this.applyFilter();
        this.onSort = () => {
          const cards = [...this.cards];
          const mode = this.sort.value;
          if (mode === 'price-ascending') cards.sort((a, b) => Number(a.dataset.price) - Number(b.dataset.price));
          if (mode === 'price-descending') cards.sort((a, b) => Number(b.dataset.price) - Number(a.dataset.price));
          if (mode === 'title-ascending') cards.sort((a, b) => a.dataset.title.localeCompare(b.dataset.title, document.documentElement.lang || 'de', { numeric: true }));
          cards.forEach(card => this.grid.appendChild(card));
        };
        this.addEventListener('click', this.onClick);
        this.sort.addEventListener('change', this.onSort);
        window.addEventListener('hashchange', this.onHistory);
        window.addEventListener('popstate', this.onHistory);
        this.querySelector('.sg-brand-accessories__filters').hidden = false;
        this.querySelector('.sg-brand-accessories__sort').hidden = false;
        this.applyFilter();
      }
      applyFilter() {
        const requested = window.location.hash.replace('#zubehoer-', '');
        const group = this.buttons.some(button => !button.hidden && button.dataset.filter === requested) ? requested : 'alle';
        let visible = 0;
        this.cards.forEach(card => {
          card.hidden = group !== 'alle' && card.dataset.group !== group;
          if (!card.hidden) visible++;
        });
        this.buttons.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.filter === group)));
        this.count.textContent = visible;
      }
      disconnectedCallback() {
        this.removeEventListener('click', this.onClick);
        this.sort?.removeEventListener('change', this.onSort);
        window.removeEventListener('hashchange', this.onHistory);
        window.removeEventListener('popstate', this.onHistory);
        this.ready = false;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sg-category-entry"]) return;
  try {
    
document.addEventListener('focusin', (event) => {
  if (!(event.target instanceof Element)) return;
  const link = event.target.closest('.sg-entry-nav__link');
  if (!link) return;
  const list = link.closest('.sg-entry-nav__list');
  if (!list || list.scrollWidth <= list.clientWidth) return;
  const bounds = list.getBoundingClientRect();
  const target = link.getBoundingClientRect();
  if (target.right > bounds.right - 4) list.scrollLeft += target.right - bounds.right + 4;
  else if (target.left < bounds.left + 4) list.scrollLeft += target.left - bounds.left - 4;
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sg-growbox-legacy-content"]) return;
  try {
    

if (!customElements.get('sg-growbox-navigation')) {
  customElements.define('sg-growbox-navigation', class extends HTMLElement {
    connectedCallback() {
      this.abort?.abort();
      this.abort = new AbortController();
      const signal = this.abort.signal;
      this.schedule = () => { if (!this.frame) this.frame = requestAnimationFrame(() => { this.frame = 0; this.update(); }); };
      this.init = () => {
        this.nav = this.querySelector('nav');
        if (!this.nav) return;
        this.header = document.querySelector('.section-header');
        this.main = document.getElementById('MainContent') || document.querySelector('main');
        this.contentBounds = [...(this.main?.querySelectorAll('.page-width') || [])];
        this.links = [...this.querySelectorAll('a[data-target]')];
        this.resolve();
        this.nav.addEventListener('click', event => this.jump(event), { signal });
        window.addEventListener('scroll', this.schedule, { passive: true, signal });
        window.addEventListener('resize', this.schedule, { passive: true, signal });
        window.addEventListener('pageshow', this.schedule, { signal });
        document.addEventListener('shopify:section:load', () => { this.resolve(); this.schedule(); }, { signal });
        document.addEventListener('shopify:section:unload', this.schedule, { signal });
        this.resizeObserver = new ResizeObserver(this.schedule);
        if (this.header) this.resizeObserver.observe(this.header);
        if (this.main) this.resizeObserver.observe(this.main);
        this.resizeObserver.observe(this.nav);
        if (this.header) {
          this.headerObserver = new MutationObserver(() => { this.animateUntil = performance.now() + 200; this.schedule(); });
          this.headerObserver.observe(this.header, { attributes: true, attributeFilter: ['class'] });
        }
        this.schedule();
      };
      if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', this.init, { once: true, signal });
      else this.init();
    }
    resolve() {
      const overviewLink = this.links.find(link => link.dataset.kind === 'overview');
      this.productSection = overviewLink ? [...(this.main?.children || [])].find(el => el.id === overviewLink.dataset.target || el.id.endsWith('__' + overviewLink.dataset.target)) : null;
      this.entries = this.links.map(link => {
        let target = document.getElementById(link.dataset.target);
        if (link.dataset.kind === 'details') target = this.main?.querySelector('.product__description');
        if (!target) target = [...(this.main?.children || [])].find(el => el.id.endsWith('__' + link.dataset.target));
        if (target && link.dataset.kind === 'overview') target = target.querySelector('h1') || target;
        else if (target && link.dataset.kind !== 'reviews') target = target.querySelector('h2, h3') || target;
        link.hidden = !target;
        if (target) {
          if (!target.id) target.id = 'sg-led-' + link.dataset.kind;
          link.href = '#' + target.id;
        }
        return { link, target };
      }).filter(entry => entry.target);
    }
    update() {
      if (!this.nav || !this.isConnected) return;
      const rect = this.header?.getBoundingClientRect();
      const offset = rect ? Math.max(0, Math.min(rect.bottom, rect.height)) : 0;
      this.style.setProperty('--sg-led-nav-top', Math.round(offset) + 'px');
      const leftEdges = this.contentBounds.filter(el => el.isConnected && el.getClientRects().length).map(el => el.getBoundingClientRect()).filter(r => r.width > 300).map(r => r.left);
      const contentLeft = leftEdges.length ? Math.min(...leftEdges) : 0;
      const side = window.innerWidth >= 1280 && window.innerHeight >= 600 && contentLeft >= 160;
      this.toggleAttribute('data-side', side);
      if (side) this.style.setProperty('--sg-led-nav-left', Math.floor(contentLeft - 148) + 'px');
      const usable = this.entries.filter(entry => entry.target.isConnected && entry.target.getClientRects().length && entry.target.getBoundingClientRect().height > 0);
      for (const entry of this.entries) entry.link.hidden = !usable.includes(entry);
      const productPassed = (this.productSection && this.productSection.getBoundingClientRect().bottom <= offset + (side ? 0 : this.nav.offsetHeight));
      const visible = window.scrollY > Number(this.dataset.reveal || 500) && productPassed && usable.length > 1;
      this.toggleAttribute('data-visible', visible);
      this.nav.inert = !visible;
      const threshold = offset + (side ? 0 : this.nav.offsetHeight) + 24;
      let current = usable[0];
      for (const entry of usable) if (entry.target.getBoundingClientRect().top <= threshold) current = entry;
      for (const entry of usable) {
        if (entry === current) entry.link.setAttribute('aria-current', 'location');
        else entry.link.removeAttribute('aria-current');
      }
      if (current && current !== this.current && visible && !side) {
        const row = this.querySelector('.sg-growbox-navigation__links');
        if (!this.nav.contains(document.activeElement)) {
          const a = current.link.getBoundingClientRect();
          const r = row.getBoundingClientRect();
          if (a.left < r.left || a.right > r.right) row.scrollBy({ left: a.left - r.left - 12, behavior: 'instant' });
        }
      }
      this.current = current;
      if (performance.now() < (this.animateUntil || 0)) this.schedule();
    }
    jump(event) {
      const link = event.target.closest('a[data-target]');
      if (!link || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.button !== 0) return;
      const entry = this.entries.find(item => item.link === link);
      if (!entry?.target.isConnected) return;
      event.preventDefault();
      const headerHeight = this.header?.offsetHeight || 0;
      const offset = headerHeight + (this.hasAttribute('data-side') ? 0 : this.nav.offsetHeight) + 16;
      entry.target.setAttribute('tabindex', '-1');
      entry.target.focus({ preventScroll: true });
      window.scrollTo({ top: Math.max(0, window.scrollY + entry.target.getBoundingClientRect().top - offset), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
    }
    disconnectedCallback() {
      this.abort?.abort();
      this.resizeObserver?.disconnect();
      this.headerObserver?.disconnect();
      cancelAnimationFrame(this.frame);
      this.frame = 0;
    }
  });
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sg-growbox-navigation"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('sg-growbox-navigation')) {
  customElements.define('sg-growbox-navigation', class extends HTMLElement {
    connectedCallback() {
      this.abort?.abort();
      this.abort = new AbortController();
      const signal = this.abort.signal;
      this.schedule = () => { if (!this.frame) this.frame = requestAnimationFrame(() => { this.frame = 0; this.update(); }); };
      this.init = () => {
        this.nav = this.querySelector('nav');
        if (!this.nav) return;
        this.header = document.querySelector('.section-header');
        this.main = document.getElementById('MainContent') || document.querySelector('main');
        this.contentBounds = [];
        this.links = [...this.querySelectorAll('a[data-target]')];
        this.resolve();
        this.nav.addEventListener('click', event => this.jump(event), { signal });
        window.addEventListener('scroll', this.schedule, { passive: true, signal });
        window.addEventListener('resize', this.schedule, { passive: true, signal });
        window.addEventListener('pageshow', this.schedule, { signal });
        document.addEventListener('shopify:section:load', () => { this.resolve(); this.schedule(); }, { signal });
        document.addEventListener('shopify:section:unload', this.schedule, { signal });
        this.resizeObserver = new ResizeObserver(this.schedule);
        if (this.header) this.resizeObserver.observe(this.header);
        if (this.main) this.resizeObserver.observe(this.main);
        this.resizeObserver.observe(this.nav);
        if (this.header) {
          this.headerObserver = new MutationObserver(() => { this.animateUntil = performance.now() + 200; this.schedule(); });
          this.headerObserver.observe(this.header, { attributes: true, attributeFilter: ['class'] });
        }
        this.schedule();
      };
      if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', this.init, { once: true, signal });
      else this.init();
    }
    resolve() {
      const overviewLink = this.links.find(link => link.dataset.kind === 'overview');
      this.productSection = overviewLink ? [...(this.main?.children || [])].find(el => el.id === overviewLink.dataset.target || el.id.endsWith('__' + overviewLink.dataset.target)) : null;
      this.entries = this.links.map(link => {
        let target = document.getElementById(link.dataset.target);
        if (link.dataset.kind === 'details') target = this.main?.querySelector('.product__description');
        if (!target) target = [...(this.main?.children || [])].find(el => el.id.endsWith('__' + link.dataset.target));
        if (target && link.dataset.kind === 'overview') target = target.querySelector('h1') || target;
        else if (target && link.dataset.kind === 'reviews') target = target.querySelector('.jdgm-review-widget') || target;
        else if (target) target = target.querySelector('h2, h3') || target;
        link.hidden = !target;
        if (target) {
          if (!target.id) target.id = 'sg-led-' + link.dataset.kind;
          link.href = '#' + target.id;
        }
        return { link, target };
      }).filter(entry => entry.target);
      this.contentBounds = [...new Set(this.entries.filter(entry => entry.link.dataset.kind !== 'overview').map(entry => entry.target.closest('.product__description') || entry.target.closest('.page-width') || entry.target.closest('.shopify-section')).filter(element => element && element !== this.productSection))];
      for (const element of this.main.querySelectorAll('.page-width')) {
        if (!this.productSection?.contains(element) && !element.querySelector('.page-width') && !this.contentBounds.includes(element)) this.contentBounds.push(element);
      }
      for (const section of this.main.children) {
        if (section !== this.productSection && !section.contains(this) && section.querySelector('h2, h3') && !section.querySelector('.page-width') && !section.classList.contains('page-width') && !this.contentBounds.includes(section)) this.contentBounds.push(section);
      }
      for (const element of this.contentBounds) {
        if (!element.classList.contains('sg-section-nav-content')) element.style.setProperty('--sg-section-nav-padding', getComputedStyle(element).paddingLeft);
        element.classList.add('sg-section-nav-content');
      }
    }
    update() {
      if (!this.nav || !this.isConnected) return;
      const rect = this.header?.getBoundingClientRect();
      const offset = rect ? Math.max(0, Math.min(rect.bottom, rect.height)) : 0;
      this.style.setProperty('--sg-led-nav-top', Math.round(offset) + 'px');
      const side = innerWidth >= 990 && innerHeight >= 600;
      for (const element of this.contentBounds) {
        const inset = Math.max(0, 176 - element.getBoundingClientRect().left) + 'px';
        if (side && element.style.getPropertyValue('--sg-section-nav-inset') !== inset) element.style.setProperty('--sg-section-nav-inset', inset);
        else if (!side) element.style.removeProperty('--sg-section-nav-inset');
      }
      const contentLeft = 176;
      this.toggleAttribute('data-side', side);
      if (side) this.style.setProperty('--sg-led-nav-left', Math.floor(contentLeft - 148) + 'px');
      const usable = this.entries.filter(entry => entry.target.isConnected && entry.target.getClientRects().length && entry.target.getBoundingClientRect().height > 0);
      for (const entry of this.entries) entry.link.hidden = !usable.includes(entry);
      const contentStart = Math.min(...usable.filter(entry => entry.link.dataset.kind !== 'overview').map(entry => entry.target.getBoundingClientRect().top));
      const revealEdge = offset + (side ? 0 : this.nav.offsetHeight) + 24;
      const productPassed = contentStart <= revealEdge || (this.productSection && this.productSection.getBoundingClientRect().bottom <= revealEdge);
      const visible = window.scrollY > Number(this.dataset.reveal || 500) && productPassed && usable.length > 1;
      this.toggleAttribute('data-visible', visible);
      this.nav.inert = !visible;
      const threshold = offset + (side ? 0 : this.nav.offsetHeight) + 24;
      let current = usable[0];
      for (const entry of usable) if (entry.target.getBoundingClientRect().top <= threshold) current = entry;
      for (const entry of usable) {
        if (entry === current) entry.link.setAttribute('aria-current', 'location');
        else entry.link.removeAttribute('aria-current');
      }
      if (current && current !== this.current && visible && !side) {
        const row = this.querySelector('.sg-growbox-navigation__links');
        if (!this.nav.contains(document.activeElement)) {
          const a = current.link.getBoundingClientRect();
          const r = row.getBoundingClientRect();
          if (a.left < r.left || a.right > r.right) row.scrollBy({ left: a.left - r.left - 12, behavior: 'instant' });
        }
      }
      this.current = current;
      if (performance.now() < (this.animateUntil || 0)) this.schedule();
    }
    jump(event) {
      const link = event.target.closest('a[data-target]');
      if (!link || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.button !== 0) return;
      const entry = this.entries.find(item => item.link === link);
      if (!entry?.target.isConnected) return;
      event.preventDefault();
      const headerRect = this.header?.getBoundingClientRect();
      const headerHeight = headerRect ? Math.max(0, Math.min(headerRect.bottom, headerRect.height)) : 0;
      const offset = headerHeight + (this.hasAttribute('data-side') ? 0 : this.nav.offsetHeight) + 16;
      entry.target.setAttribute('tabindex', '-1');
      entry.target.focus({ preventScroll: true });
      window.scrollTo({ top: Math.max(0, window.scrollY + entry.target.getBoundingClientRect().top - offset), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
    }
    disconnectedCallback() {
      for (const element of this.contentBounds || []) {
        element.classList.remove('sg-section-nav-content');
        element.style.removeProperty('--sg-section-nav-padding');
        element.style.removeProperty('--sg-section-nav-inset');
      }
      this.abort?.abort();
      this.resizeObserver?.disconnect();
      this.headerObserver?.disconnect();
      cancelAnimationFrame(this.frame);
      this.frame = 0;
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sg-home-categories"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('sg-home-visual-categories')) {
 customElements.define('sg-home-visual-categories', class extends HTMLElement {
  connectedCallback() {
   if (this.dataset.motion !== 'true' || matchMedia('(prefers-reduced-motion: reduce)').matches || !('IntersectionObserver' in window)) return;
   this.observer = new IntersectionObserver(entries => {
    for (const entry of entries) {
     if (!entry.isIntersecting) continue;
     if (!matchMedia('(prefers-reduced-motion: reduce)').matches) entry.target.animate([{ transform:'translateY(14px)' }, { transform:'translateY(0)' }], { duration:420, easing:'cubic-bezier(.2,.65,.3,1)' });
     this.observer.unobserve(entry.target);
    }
   }, { threshold:.08 });
   this.querySelectorAll('.sg-home-categories__item').forEach(item => this.observer.observe(item));
  }
  disconnectedCallback() { this.observer?.disconnect(); }
 });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sg-led-navigation"]) return;
  try {
    
if (!customElements.get('sg-led-navigation')) {
  customElements.define('sg-led-navigation', class extends HTMLElement {
    connectedCallback() {
      this.abort?.abort();
      this.abort = new AbortController();
      const signal = this.abort.signal;
      this.schedule = () => { if (!this.frame) this.frame = requestAnimationFrame(() => { this.frame = 0; this.update(); }); };
      this.init = () => {
        this.nav = this.querySelector('nav');
        if (!this.nav) return;
        this.header = document.querySelector('.section-header');
        this.main = document.getElementById('MainContent') || document.querySelector('main');
        this.contentBounds = [];
        for (let section = this.closest('.shopify-section')?.nextElementSibling; section; section = section.nextElementSibling) {
          this.contentBounds.push(...section.querySelectorAll('.page-width'));
        }
        this.links = [...this.querySelectorAll('a[data-target]')];
        this.resolve();
        this.nav.addEventListener('click', event => this.jump(event), { signal });
        window.addEventListener('scroll', this.schedule, { passive: true, signal });
        window.addEventListener('resize', this.schedule, { passive: true, signal });
        window.addEventListener('pageshow', this.schedule, { signal });
        document.addEventListener('shopify:section:load', () => { this.resolve(); this.schedule(); }, { signal });
        document.addEventListener('shopify:section:unload', this.schedule, { signal });
        this.resizeObserver = new ResizeObserver(this.schedule);
        if (this.header) this.resizeObserver.observe(this.header);
        if (this.main) this.resizeObserver.observe(this.main);
        this.resizeObserver.observe(this.nav);
        if (this.header) {
          this.headerObserver = new MutationObserver(() => { this.animateUntil = performance.now() + 200; this.schedule(); });
          this.headerObserver.observe(this.header, { attributes: true, attributeFilter: ['class'] });
        }
        this.schedule();
      };
      if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', this.init, { once: true, signal });
      else this.init();
    }
    resolve() {
      const overviewLink = this.links.find(link => link.dataset.kind === 'overview');
      this.productSection = overviewLink ? [...(this.main?.children || [])].find(el => el.id === overviewLink.dataset.target || el.id.endsWith('__' + overviewLink.dataset.target)) : null;
      this.entries = this.links.map(link => {
        let target = document.getElementById(link.dataset.target);
        if (link.dataset.kind === 'details') {
          const descriptionSection = [...(this.main?.children || [])].find(section => section.id.endsWith('__accordion_collapse_kXzB3j'));
          target = descriptionSection?.querySelector('h2, h3') || this.main?.querySelector('.product__description');
        }
        if (!target) target = [...(this.main?.children || [])].find(el => el.id.endsWith('__' + link.dataset.target));
        if (target && link.dataset.kind === 'overview') target = target.querySelector('h1') || target;
        else if (target && link.dataset.kind === 'reviews') target = target.querySelector('.jdgm-review-widget') || target;
        else if (target) target = target.querySelector('h2, h3') || target;
        link.hidden = !target;
        if (target) {
          if (!target.id) target.id = 'sg-led-' + link.dataset.kind;
          link.href = '#' + target.id;
        }
        return { link, target };
      }).filter(entry => entry.target);
    }
    update() {
      if (!this.nav || !this.isConnected) return;
      const rect = this.header?.getBoundingClientRect();
      const offset = rect ? Math.max(0, Math.min(rect.bottom, rect.height)) : 0;
      this.style.setProperty('--sg-led-nav-top', Math.round(offset) + 'px');
      const desktop = window.innerWidth >= 990 && window.innerHeight >= 600;
      const bounds = this.contentBounds.filter(el => el.isConnected && el.getClientRects().length).map(el => ({ el, rect: el.getBoundingClientRect() })).filter(({ rect }) => rect.width > 300);
      for (const { el, rect: contentRect } of bounds) {
        const inset = Math.max(0, 176 - contentRect.left) + 'px';
        if (desktop && el.style.getPropertyValue('--sg-led-content-inset') !== inset) el.style.setProperty('--sg-led-content-inset', inset);
        else if (!desktop && el.style.getPropertyValue('--sg-led-content-inset')) el.style.removeProperty('--sg-led-content-inset');
      }
      const leftEdges = bounds.map(({ el, rect: contentRect }) => contentRect.left + parseFloat(getComputedStyle(el).paddingLeft));
      const contentLeft = leftEdges.length ? Math.min(...leftEdges) : 0;
      const side = desktop && contentLeft >= 160;
      this.toggleAttribute('data-side', side);
      if (side) this.style.setProperty('--sg-led-nav-left', Math.floor(contentLeft - 148) + 'px');
      const usable = this.entries.filter(entry => entry.target.isConnected && entry.target.getClientRects().length && entry.target.getBoundingClientRect().height > 0);
      for (const entry of this.entries) entry.link.hidden = !usable.includes(entry);
      const contentStart = Math.min(...usable.filter(entry => entry.link.dataset.kind !== 'overview').map(entry => entry.target.getBoundingClientRect().top));
      const revealEdge = offset + (side ? 0 : this.nav.offsetHeight) + 24;
      const productPassed = contentStart <= revealEdge || (this.productSection && this.productSection.getBoundingClientRect().bottom <= revealEdge);
      const visible = window.scrollY > Number(this.dataset.reveal || 500) && productPassed && usable.length > 1;
      this.toggleAttribute('data-visible', visible);
      this.nav.inert = !visible;
      const threshold = offset + (side ? 0 : this.nav.offsetHeight) + 24;
      let current = usable[0];
      for (const entry of usable) if (entry.target.getBoundingClientRect().top <= threshold) current = entry;
      for (const entry of usable) {
        if (entry === current) entry.link.setAttribute('aria-current', 'location');
        else entry.link.removeAttribute('aria-current');
      }
      if (current && current !== this.current && visible && !side) {
        const row = this.querySelector('.sg-led-navigation__links');
        if (!this.nav.contains(document.activeElement)) {
          const a = current.link.getBoundingClientRect();
          const r = row.getBoundingClientRect();
          if (a.left < r.left || a.right > r.right) row.scrollBy({ left: a.left - r.left - 12, behavior: 'instant' });
        }
      }
      this.current = current;
      if (performance.now() < (this.animateUntil || 0)) this.schedule();
    }
    jump(event) {
      const link = event.target.closest('a[data-target]');
      if (!link || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.button !== 0) return;
      const entry = this.entries.find(item => item.link === link);
      if (!entry?.target.isConnected) return;
      event.preventDefault();
      const headerRect = this.header?.getBoundingClientRect();
      const headerHeight = headerRect ? Math.max(0, Math.min(headerRect.bottom, headerRect.height)) : 0;
      const offset = headerHeight + (this.hasAttribute('data-side') ? 0 : this.nav.offsetHeight) + 16;
      entry.target.setAttribute('tabindex', '-1');
      entry.target.focus({ preventScroll: true });
      window.scrollTo({ top: Math.max(0, window.scrollY + entry.target.getBoundingClientRect().top - offset), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
    }
    disconnectedCallback() {
      this.abort?.abort();
      this.resizeObserver?.disconnect();
      this.headerObserver?.disconnect();
      for (const el of this.contentBounds || []) el.style.removeProperty('--sg-led-content-inset');
      cancelAnimationFrame(this.frame);
      this.frame = 0;
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sg-led-preserved-entry"]) return;
  try {
    
document.addEventListener('focusin', (event) => {
  if (!(event.target instanceof Element)) return;
  const link = event.target.closest('.sg-led-entry-nav__link');
  if (!link) return;
  const list = link.closest('.sg-led-entry-nav__list');
  if (!list || list.scrollWidth <= list.clientWidth) return;
  const bounds = list.getBoundingClientRect();
  const target = link.getBoundingClientRect();
  if (target.right > bounds.right - 4) list.scrollLeft += target.right - bounds.right + 4;
  else if (target.left < bounds.left + 4) list.scrollLeft += target.left - bounds.left - 4;
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sg-mh-word-entry"]) return;
  try {
    
document.addEventListener('focusin', (event) => {
  if (!(event.target instanceof Element)) return;
  const link = event.target.closest('.sg-led-entry-nav__link');
  if (!link) return;
  const list = link.closest('.sg-led-entry-nav__list');
  if (!list || list.scrollWidth <= list.clientWidth) return;
  const bounds = list.getBoundingClientRect();
  const target = link.getBoundingClientRect();
  if (target.right > bounds.right - 4) list.scrollLeft += target.right - bounds.right + 4;
  else if (target.left < bounds.left + 4) list.scrollLeft += target.left - bounds.left - 4;
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sg-set-configurator"] && !Shopify.designMode) return;
  try {
    
class SGSetConfigurator extends HTMLElement {
connectedCallback(){if(this._started){this._resume?.();return;}this._started=true;const root=this;const config=JSON.parse(root.querySelector('[data-config]').textContent);
const t=key=>config.i18n[key]??key;
const tr=(key,args)=>t(key).replace(/__SG(\d+)__/g,(_,n)=>args[Number(n)]??'');
const steps=[t("ui_140"),t("ui_136"),t("ui_135"),t("ui_134"),t("ui_139"),t("ui_138"),t("ui_131"),t("ui_114"),t("ui_129"),t("ui_137")];
const kinds=['tent','led','exhaust','fan','soil','fertilizer','bundle','pot','accessory'];
const labels={tent:t("ui_136"),led:t("ui_135"),exhaust:t("ui_134"),fan:t("ui_133"),soil:t("ui_132"),fertilizer:t("ui_131"),bundle:t("ui_130"),pot:t("ui_114"),accessory:t("ui_129")};
const kindStep={tent:1,led:2,exhaust:3,fan:4,soil:5,fertilizer:6,bundle:6,pot:7,accessory:8};
const singleKinds=['tent','led','exhaust','fan','fertilizer','bundle'];
function initial(){return {step:0,entry:null,size:null,items:{},manualLED:null,finished:false};}
function selectedProducts(s,ps){return Object.entries(s.items).map(([id,qty])=>{const p=ps.find(x=>x.id===id);return p?{...p,quantity:qty,lineTotal:p.price*qty}:null;}).filter(Boolean).sort((a,b)=>kinds.indexOf(a.kind)-kinds.indexOf(b.kind));}
function total(s,ps){return selectedProducts(s,ps).reduce((n,p)=>n+p.lineTotal,0);}
function removeKind(s,kind,ps){for(const p of ps)if(p.kind===kind)delete s.items[p.id];if(kind==='led')s.manualLED=null;s.finished=false;}
function recommended(p,s){return p.kind==='led'&&p.sizes.includes(s.size);}
function exhaustFits(p,s,ps){const tent=selectedProducts(s,ps).find(x=>x.kind==='tent');return p.kind==='exhaust'&&p.exhaustSizes.includes(s.size)&&(!(s.size==='140x70'&&p.masterOnlyRectangle)||tent?.productId==='15928044945792');}
function tentConfigurable(p,ps){
 if(!p.size)return false;
 const draft={size:p.size,items:{[p.id]:1}};
 return ps.some(l=>l.kind==='led'&&l.stock&&l.sizes.includes(p.size))&&ps.some(e=>e.stock&&exhaustFits(e,draft,ps));
}
function eligible(p){return !!p.stock;}
function choose(s,id,ps,{allowAlternative=false}={}){
 const p=ps.find(x=>x.id===id);if(!p||!eligible(p))return false;
 if(p.kind==='exhaust'&&!exhaustFits(p,s,ps))return false;
 if(p.kind==='led'&&(!s.size||(!recommended(p,s)&&!allowAlternative)))return false;
 if(p.kind==='tent'){
  if(!tentConfigurable(p,ps))return false;
  const old=selectedProducts(s,ps).find(x=>x.kind==='tent');
  if(old&&old.id!==p.id){removeKind(s,'led',ps);removeKind(s,'exhaust',ps);}
  s.size=p.size;
 }
 const prev=s.items[id]||1;
 if(singleKinds.includes(p.kind))removeKind(s,p.kind,ps);
 if(p.kind==='bundle'){removeKind(s,'soil',ps);removeKind(s,'fertilizer',ps);}
 if(p.kind==='soil'||p.kind==='fertilizer')removeKind(s,'bundle',ps);
 s.items[id]=Math.min(prev,p.maxQuantity);if(p.kind==='led')s.manualLED=recommended(p,s)?null:id;
 s.finished=false;return true;
}
function setQuantity(s,id,qty,ps){const p=ps.find(x=>x.id===id);if(!p||!s.items[id]||!Number.isInteger(qty)||qty<1||qty>p.maxQuantity||p.kind==='tent'&&qty!==1)return false;s.items[id]=qty;s.finished=false;return true;}
function remove(s,id,ps){const p=ps.find(x=>x.id===id);if(!p)return;delete s.items[id];if(p.kind==='tent'){s.size=null;removeKind(s,'led',ps);removeKind(s,'exhaust',ps);}if(p.kind==='led')s.manualLED=null;s.finished=false;}
function ready(step,s,ps){
 const has=k=>ps.some(p=>p.kind===k&&s.items[p.id]&&p.stock);
 if(step===0)return s.entry!==null;
 if(step===1)return ps.some(p=>p.kind==='tent'&&s.items[p.id]&&p.stock&&tentConfigurable(p,ps));
 if(step===2)return ps.some(p=>p.kind==='led'&&s.items[p.id]&&p.stock&&(recommended(p,s)||s.manualLED===p.id));
 if(step===3)return ps.some(p=>s.items[p.id]&&p.stock&&exhaustFits(p,s,ps));
 if(step>=4&&step<9)return true;
 return [0,1,2,3].every(n=>ready(n,s,ps));
}
function reachable(step,s,ps){return Number.isInteger(step)&&step>=0&&step<steps.length&&Array.from({length:step},(_,i)=>i).every(n=>ready(n,s,ps));}
function fanCount(s,ps){return selectedProducts(s,ps).reduce((n,p)=>n+(p.kind==='fan'?p.quantity*p.packSize:p.kind==='exhaust'?p.quantity*p.includedFans:0),0);}
function warnings(s,ps){
 const a=selectedProducts(s,ps),notes=[],led=a.find(p=>p.kind==='led'),ex=a.find(p=>p.kind==='exhaust'),fert=a.find(p=>p.kind==='fertilizer'),soil=a.filter(p=>p.kind==='soil');
 if(led&&!recommended(led,s))notes.push(t("ui_128"));
 if(led&&led.quantity>1)notes.push(t("ui_127"));
 if(ex&&s.size){const [l,w]=s.size.split('x').map(Number);if(ex.diameter===100&&(l*w>9000||l>140)||ex.diameter===150&&(l*w>22500||l>150))notes.push(t("ui_126"));}
 if(fert&&['earth','coco','hydro'].includes(fert.medium)&&soil.some(p=>p.medium!==fert.medium))notes.push(t("ui_125"));
 if(fert?.medium==='hydro')notes.push(t("ui_124"));
 for(const p of a)for(const note of p.notes)notes.push(note);
 return [...new Set(notes)];
}

const $=s=>root.querySelector(s);
const euro=n=>new Intl.NumberFormat(document.documentElement.lang||'de-DE',{style:'currency',currency:config.currency}).format(n/100);
const esc=s=>String(s??'').replace(/[&<>"']/g,c=>({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]));
const sizeLabel=s=>s&&s!=='all'?s.replace('x',t("ui_122"))+' cm':t("ui_065");
let state=initial(),products=[],toastTimer,pendingLED=null;
const view={size:'all',brands:{},variants:{},ledMode:'recommended',ledBase:0,accessoryGroup:'all',potType:'all',fertMedium:'all'};
const plant='<svg viewBox="0 0 60 110" fill="none" aria-hidden="true"><path d="M19 86h23l-4 19H23z" fill="#cbdba6" stroke="currentColor" stroke-width="1.4"/><path d="M30 86V26M30 67C8 65 7 46 7 46c21 0 23 21 23 21zm0-14c23-4 23-22 23-22-22 1-23 22-23 22zm0-15C16 26 29 9 29 9c13 15 1 29 1 29z" stroke="currentColor" stroke-width="1.4" stroke-linejoin="round" fill="#e5edce"/></svg>';
function toast(text){clearTimeout(toastTimer);$('#sg-config-notice').textContent=text;$('#sg-config-notice').classList.add('visible');toastTimer=setTimeout(()=>$('#sg-config-notice').classList.remove('visible'),6000);}
function head(title,text){return tr("ui_121_html",[title,text]);}
function dropdown(label,attr,values,current){return tr("ui_119_html",[label,attr,values.map(([v,n])=>tr("ui_120_html",[esc(v),v===current?'selected':'',esc(n)])).join('')]);}
function brandFilter(kind){const brands=[...new Set(products.filter(p=>p.kind===kind).map(p=>p.brand))].sort();return dropdown(t("ui_118"),`data-brand="${kind}"`,[['all',t("ui_117")],...brands.map(b=>[b,b])],view.brands[kind]||'all');}
function quantityText(p,qty){return p.packSize>1?`${qty} × ${p.packSize}er-Pack = ${qty*p.packSize} ${p.kind==='fan'?t("ui_116"):t("ui_114")}`:`${qty} ${p.kind==='fan'?'Ventilator'+(qty>1?'en':''):p.kind==='pot'?(qty===1?t("ui_115"):t("ui_114")):t("ui_113")}`;}
function quantityControl(p){const qty=state.items[p.id]||1;return tr("ui_110_html",[p.packSize>1?t("ui_112"):t("ui_111"),p.id,qty<=1?'disabled':'',p.maxQuantity,qty,p.id,esc(p.title),p.id,qty>=p.maxQuantity?'disabled':'']);}
function selectionStrip(kind){const a=selectedProducts(state,products).filter(p=>p.kind===kind);if(!a.length)return '';return tr("ui_108_html",[a.map(p=>tr("ui_109_html",[p.quantity,esc(p.title),p.variant?' · '+esc(p.variant):'',p.id,esc(p.title)])).join('')]);}
function visibleProducts(kind){return products.filter(p=>{
 if(p.kind!==kind)return false;
 if(kind==='tent'&&!tentConfigurable(p,products))return false;
 if(kind==='exhaust'&&!exhaustFits(p,state,products))return false;
 if(view.brands[kind]&&view.brands[kind]!=='all'&&p.brand!==view.brands[kind])return false;
 if(kind==='tent'&&view.size!=='all'&&p.size!==view.size)return false;
 if(kind==='led'&&view.ledMode==='recommended'&&!recommended(p,state))return false;
 if(kind==='led'&&view.ledMode==='larger'&&!(p.watts>view.ledBase))return false;
 if(kind==='accessory'&&view.accessoryGroup!=='all'&&p.group!==view.accessoryGroup)return false;
 if(kind==='pot'&&view.potType!=='all'&&((view.potType==='plastic')!==/Kunststoff/i.test(p.title)))return false;
 if(kind==='fertilizer'&&view.fertMedium!=='all'&&p.medium!==view.fertMedium)return false;
 return true;
 });}
const preferredLEDs={"60x60":["15543280730496","15543287939456"],"70x70":["15543280730496","15543287939456"],"90x90":["15543284269440"],"100x100":["15543287873920"],"120x60":["15543277977984"],"120x120":["15547331576192","15543289807232"],"140x70":["15543286235520"],"150x150":["15543285219712","15543289348480"]};
function shopRecommendation(p){return p.kind==='led'&&p.stock&&recommended(p,state)&&(preferredLEDs[state.size]||[]).includes(p.productId);}
const entryTentSizes={small:['60x60','70x70','80x80'],medium:['90x90','100x100'],large:['120x120','150x150']};
function tentRecommendations(list){
 const sizes=view.size!=='all'?[view.size]:(entryTentSizes[state.entry]||[]);
 if(!sizes.length)return new Set();
 const brandKey=p=>p.brand.toLowerCase().replace(/[^a-z]/g,'');
 const brandOrder=['spiderfarmer','marshydro','homebox','gardenhighpro'];
 const tier=p=>/master/i.test(p.title)?3:/\bpro\b|ambient/i.test(p.title)?2:1;
 const candidates=list.filter(p=>p.stock&&sizes.includes(p.size)&&products.some(l=>l.kind==='led'&&l.stock&&l.sizes.includes(p.size))&&products.some(e=>e.stock&&exhaustFits(e,{...state,size:p.size,items:{[p.id]:1}},products)));
 candidates.sort((a,b)=>sizes.indexOf(a.size)-sizes.indexOf(b.size)||tier(b)-tier(a)||(b.height||0)-(a.height||0)||a.price-b.price||a.id.localeCompare(b.id));
 const byBrand=new Map();for(const p of candidates)if(!byBrand.has(brandKey(p)))byBrand.set(brandKey(p),p);
 const rank=p=>{const n=brandOrder.indexOf(brandKey(p));return n<0?brandOrder.length:n;};
 return new Set([...byBrand.values()].sort((a,b)=>rank(a)-rank(b)||a.price-b.price).slice(0,3).map(p=>p.productId));
}
function cards(kind){
 const list=visibleProducts(kind),tentPicks=kind==='tent'?tentRecommendations(list):new Set(),isPick=p=>p.kind==='tent'?p.stock&&tentPicks.has(p.productId):shopRecommendation(p),groups=new Map();for(const p of list){if(!groups.has(p.productId))groups.set(p.productId,[]);groups.get(p.productId).push(p);}
 const sorted=[...groups.values()].sort((a,b)=>Number(b.some(p=>p.stock))-Number(a.some(p=>p.stock))||Number(b.some(isPick))-Number(a.some(isPick))||(kind==='led'?(a[0].watts||9999)-(b[0].watts||9999):a[0].price-b[0].price));
 if(!sorted.length&&kind==='exhaust'&&!products.some(p=>exhaustFits(p,state,products)))return t("ui_107_html");
 if(!sorted.length)return tr("ui_103_html",[kind==='led'&&view.ledMode==='recommended'?t("ui_105"):t("ui_104"),kind==='led'?t("ui_106_html"):'<button class="secondary" data-clear-filters="'+kind+'">Auswahlfilter zurücksetzen</button>']);
 return tr("ui_085_html",[sorted.length,kind==='led'?t("ui_086"):'',sorted.map(variants=>{
 const preferred=view.variants[variants[0].productId];const p=variants.find(x=>x.id===preferred)||variants.find(x=>state.items[x.id])||variants.find(x=>x.stock)||variants[0];
 const selected=!!state.items[p.id];const variantOptions=variants.map(v=>tr("ui_100_html",[v.id,p.id===v.id?'selected':'',esc(v.variant||t("ui_101")),euro(v.price),!v.stock?t("ui_102"):''])).join('');
 const notes=[...p.notes];if(p.kind==='led'&&!recommended(p,state))notes.unshift(t("ui_099"));if(p.includedFans)notes.unshift(t("ui_098"));
 return tr("ui_087_html",[p.productId,selected?'selected':'',p.id,selected,!p.stock?'disabled':'',esc(p.title+' '+p.variant+' '+euro(p.price)),esc(p.image),esc(p.title),esc(p.brand),esc(p.title),esc(p.detail),euro(p.price),!p.stock?t("ui_090"):selected?t("ui_089"):t("ui_088"),variants.length>1?tr("ui_092_html",[p.productId,esc(p.title),variantOptions]):p.variant?tr("ui_091_html",[esc(p.variant)]):'',notes.map(n=>tr("ui_093_html",[esc(n)])).join(''),selected&&p.kind!=='tent'?quantityControl(p):selected?t("ui_096_html"):'<span class="fine">'+(p.packSize>1?tr("ui_095_html",[p.packSize]):t("ui_094"))+'</span>',selected&&['pot','fan'].includes(p.kind)?tr("ui_097_html",[quantityText(p,state.items[p.id])]):'',esc(p.url),p.url.includes('?')?'&':'?',p.id,['tent','led'].includes(kind)?(isPick(p)?'<span class="recommendation-slot"><span class="recommendation-badge" title="'+esc(t(kind==='tent'?(view.size!=='all'?'tent_recommendation_size':'tent_recommendation_entry'):'recommendation_reason'))+'">'+esc(t('recommendation_label'))+'</span></span>':'<span class="recommendation-slot" aria-hidden="true"></span>'):'']);
 }).join('')]);
}
function overview(){const list=selectedProducts(state,products),notes=warnings(state,products);
 return (state.finished?tr("ui_084_html",[list.length]):head(t("ui_083"),t("ui_082")))+tr("ui_077_html",[list.map(p=>tr("ui_078_html",[esc(p.image),labels[p.kind],p.quantity,esc(p.title),p.variant?tr("ui_079_html",[esc(p.variant)]):'',p.packSize>1?tr("ui_079_html",[quantityText(p,p.quantity)]):'',kindStep[p.kind],euro(p.lineTotal)])).join(''),euro(total(state,products)),fanCount(state,products),notes.length?tr("ui_080_html",[notes.map(n=>tr("ui_081_html",[esc(n)])).join('')]):'']);
}
function screen(){switch(state.step){
 case 0:return head(t("ui_076"),t("ui_075"))+tr("ui_070_html",[[['small','1–2',t("ui_074"),1],['medium','3–4',t("ui_073"),2],['large','5–6',t("ui_072"),3]].map(([id,n,t,count])=>tr("ui_071_html",[id,state.entry===id,plant.repeat(count),n,t])).join(''),state.entry==='size']);
 case 1:{const sizes=[...new Set(products.filter(p=>p.kind==='tent').map(p=>p.size))].sort((a,b)=>{const area=s=>s.split('x').reduce((a,b)=>a*b,1);return area(a)-area(b);});return head(t("ui_069"),t("ui_068"))+tr("ui_064_html",[dropdown(t("ui_066"),'data-size-select',[['all',t("ui_065")],...sizes.map(s=>[s,sizeLabel(s)])],view.size),brandFilter('tent'),['all',...sizes].map(s=>tr("ui_067_html",[s,view.size===s,sizeLabel(s)])).join('')])+selectionStrip('tent')+cards('tent');}
 case 2:return head(t("ui_063"),tr("ui_062_html",[sizeLabel(state.size)]))+tr("ui_059_html",[view.ledMode==='recommended',view.ledMode==='larger',view.ledMode==='all',brandFilter('led'),view.ledMode==='larger'?tr("ui_060_html",[view.ledBase,view.ledBase?t("ui_061"):'']):''])+selectionStrip('led')+cards('led')+t("extra_176_html");
 case 3:return head(t("ui_058"),tr("ui_057_html",[sizeLabel(state.size)]))+tr("ui_050_html",[brandFilter('exhaust')])+selectionStrip('exhaust')+cards('exhaust')+t("extra_175_html");
 case 4:{const included=selectedProducts(state,products).filter(p=>p.kind==='exhaust').reduce((n,p)=>n+p.includedFans*p.quantity,0);return head(t("ui_056"),t("ui_055"))+tr("ui_053_html",[included?tr("ui_054_html",[included]):'',fanCount(state,products),brandFilter('fan')])+selectionStrip('fan')+cards('fan')+t("extra_174_html");}
 case 5:return head(t("ui_052"),t("ui_051"))+tr("ui_050_html",[brandFilter('soil')])+selectionStrip('soil')+cards('soil')+t("extra_173_html");
 case 6:return head(t("ui_049"),t("ui_048"))+tr("ui_026_html",[brandFilter('fertilizer'),dropdown(t("ui_047"),'data-fert-medium',[['all',t("ui_046")],['earth',t("ui_045")],['coco',t("ui_044")],['hydro',t("ui_043")],['unknown',t("ui_042")]],view.fertMedium)])+selectionStrip('fertilizer')+cards('fertilizer')+tr("ui_041_html",[])+selectionStrip('bundle')+cards('bundle')+t("extra_172_html");
 case 7:return head(t("ui_040"),t("ui_039"))+tr("ui_026_html",[brandFilter('pot'),dropdown(t("ui_038"),'data-pot-type',[['all',t("ui_037")],['fabric',t("ui_036")],['plastic',t("ui_035")]],view.potType)])+selectionStrip('pot')+cards('pot')+t("extra_171_html");
 case 8:return head(t("ui_034"),t("ui_033"))+tr("ui_026_html",[dropdown(t("ui_032"),'data-accessory-group',[['all',t("ui_031")],...[t("ui_030"),t("ui_029"),t("ui_028"),t("ui_027")].map(s=>[s,s])],view.accessoryGroup),brandFilter('accessory')])+selectionStrip('accessory')+cards('accessory');
 case 9:return overview();
}}
function render(){const selection=selectedProducts(state,products),tent=selection.find(p=>p.kind==='tent');
 $('#sg-config-steps').innerHTML=steps.map((name,i)=>tr("ui_025_html",[i<state.step?'done':'',i,!reachable(i,state,products)?'disabled':'',i===state.step?'aria-current="step"':'',i<state.step?'✓':i+1,name])).join('');
 $('#sg-config-screen').innerHTML=screen();
 $('#sg-config-summary').innerHTML=tr("ui_019_html",[selection.length,tent?tr("ui_021_html",[esc(tent.image),esc(tent.title)]):tr("ui_020_html",[plant]),selection.length?selection.map(p=>tr("ui_023_html",[labels[p.kind],p.quantity,kindStep[p.kind],esc(p.title),p.variant?tr("ui_024_html",[esc(p.variant)]):'',euro(p.lineTotal)])).join(''):t("ui_022_html"),euro(total(state,products))]);
 $('#sg-config-actionbar').innerHTML=tr("ui_014_html",[selection.length?t("summary_label"):t("ui_015"),euro(total(state,products)),state.step?t("ui_016_html"):'',state.finished?'download':'next',!ready(state.step,state,products)||cartBusy||cartLocked?'disabled':'',cartBusy?t('checking'):state.finished?t("ui_018"):state.step===9?t('add_to_cart'):state.step>=4&&state.step<=7?t("ui_017"):t("ui_017")]);
}
function preserve(selector){const y=window.scrollY;render();if(selector)$(selector)?.focus({preventScroll:true});window.scrollTo({top:y,behavior:'instant'});}
function go(step){if(!reachable(step,state,products))return;state.step=step;render();$('#sg-config-workspace').focus({preventScroll:true});window.scrollTo({top:window.scrollY+$('#sg-config-workspace').getBoundingClientRect().top-(parseFloat(root.style.getPropertyValue('--sg-top'))||0)-16,behavior:'instant'});const nav=$('.step[aria-current="step"]');$('#sg-config-steps').scrollLeft=nav.offsetLeft-$('#sg-config-steps').offsetLeft-10;}
function handleChoice(id){const p=products.find(x=>x.id===id);if(!p||!p.stock)return;
 if(p.kind==='led'&&!recommended(p,state)){pendingLED=id;$('#sg-config-led-choice-title').textContent=p.title;$('#sg-config-led-dialog').showModal();return;}
 const previous=selectedProducts(state,products).find(x=>x.kind==='tent');choose(state,id,products);if(p.kind==='tent'&&previous&&previous.id!==id)toast(t("ui_013"));preserve(`[data-choose="${id}"]`);
}
function download(){const list=selectedProducts(state,products);const text=[t("ui_012"),t("ui_011"),tr("ui_010_html",[sizeLabel(state.size)]),...list.map(p=>`${labels[p.kind]}: ${p.quantity} × ${p.title}${p.variant?' – '+p.variant:''}\nEinzelpreis: ${euro(p.price)} · Gesamt: ${euro(p.lineTotal)}${p.packSize>1?'\n'+quantityText(p,p.quantity):''}\n${p.url}?variant=${p.id}`),tr("ui_009_html",[euro(total(state,products))]),tr("ui_008_html",[fanCount(state,products)]),...warnings(state,products)].join("\n\n");const blob=new Blob([text],{type:'text/plain;charset=utf-8'}),url=URL.createObjectURL(blob),a=document.createElement('a');a.href=url;a.download='Simple-Grow-Konfiguration.txt';a.click();setTimeout(()=>URL.revokeObjectURL(url),1000);toast(t("ui_004"));}
function clearFilters(kind){view.brands[kind]='all';if(kind==='tent')view.size='all';if(kind==='fertilizer')view.fertMedium='all';if(kind==='pot')view.potType='all';if(kind==='accessory')view.accessoryGroup='all';}
 root.addEventListener('click',event=>{
 if(cartBusy||cartLocked)return;const b=event.target.closest('button');if(!b||b.disabled)return;
 if(b.dataset.entry){state.entry=b.dataset.entry;state.finished=false;view.size='all';view.brands.tent='all';preserve(`[data-entry="${state.entry}"]`);}
 if(b.dataset.size){view.size=b.dataset.size;preserve(`[data-size="${view.size}"]`);}
 if(b.dataset.mode){view.ledMode=b.dataset.mode;if(view.ledMode==='larger'){const picked=selectedProducts(state,products).find(p=>p.kind==='led');const recommendedWatts=products.filter(p=>recommended(p,state)&&p.watts).map(p=>p.watts);view.ledBase=picked?.watts||Math.min(...recommendedWatts,Infinity);if(!Number.isFinite(view.ledBase))view.ledBase=0;}preserve(`[data-mode="${view.ledMode}"]`);}
 if(b.dataset.choose)handleChoice(b.dataset.choose);
 if(b.dataset.remove){remove(state,b.dataset.remove,products);preserve();}
 if(b.dataset.quantity){const id=b.dataset.quantity;setQuantity(state,id,state.items[id]+Number(b.dataset.delta),products);preserve(`[data-quantity="${id}"][data-delta="${b.dataset.delta}"]`);}
 if(b.dataset.clearFilters){clearFilters(b.dataset.clearFilters);preserve();}
 if(b.dataset.step!==undefined){go(Number(b.dataset.step));return;}
 if(b.dataset.action==='back'){go(Math.max(0,state.step-1));return;}
 if(b.dataset.action==='next'&&ready(state.step,state,products)){if(state.step===9){addConfiguration();}else go(state.step+1);return;}
 if(b.dataset.action==='reset')$('#sg-config-reset-dialog').showModal();
 if(b.dataset.action==='cancel-reset')$('#sg-config-reset-dialog').close();
 if(b.dataset.action==='confirm-reset'){$('#sg-config-reset-dialog').close();state=initial();Object.assign(view,{size:'all',brands:{},variants:{},ledMode:'recommended',ledBase:0,accessoryGroup:'all',potType:'all',fertMedium:'all'});go(0);return;}
 if(b.dataset.action==='cancel-led'){$('#sg-config-led-dialog').close();pendingLED=null;}
 if(b.dataset.action==='confirm-led'){const id=pendingLED;$('#sg-config-led-dialog').close();pendingLED=null;if(id){choose(state,id,products,{allowAlternative:true});preserve(`[data-choose="${id}"]`);toast(t("ui_003"));}}
 if(b.dataset.action==='download')download();
 if(b.dataset.action==='cart-open')window.location.assign(config.cartUrl);
 });
 root.addEventListener('change',event=>{if(cartBusy||cartLocked)return;const e=event.target,d=e.dataset;if(!d)return;
 if(d.brand){view.brands[d.brand]=e.value;preserve(`[data-brand="${d.brand}"]`);}
 if(d.sizeSelect!==undefined){view.size=e.value;preserve('[data-size-select]');}
 if(d.variant){view.variants[d.variant]=e.value;preserve(`[data-variant="${d.variant}"]`);}
 if(d.potType!==undefined){view.potType=e.value;preserve('[data-pot-type]');}
 if(d.fertMedium!==undefined){view.fertMedium=e.value;preserve('[data-fert-medium]');}
 if(d.accessoryGroup!==undefined){view.accessoryGroup=e.value;preserve('[data-accessory-group]');}
 if(d.quantityInput){if(!setQuantity(state,d.quantityInput,Number(e.value),products))toast(t("ui_002"));preserve(`[data-quantity-input="${d.quantityInput}"]`);}
 });

let cartBusy=false,cartLocked=false;
const pendingKey='sg-configurator-pending-v1';
function cartMessage(text){toast(text);const box=$('[data-cart-message]');box.textContent=text;box.hidden=false;box.setAttribute('tabindex','-1');box.focus({preventScroll:true});}
function storePending(value){try{if(value)sessionStorage.setItem(pendingKey,JSON.stringify(value));else sessionStorage.removeItem(pendingKey);}catch{}}
function readPending(){try{return JSON.parse(sessionStorage.getItem(pendingKey)||'null');}catch{return null;}}
async function requestJSON(url,options={}){const abort=new AbortController(),timer=setTimeout(()=>abort.abort(),15000);try{const response=await fetch(url,{credentials:'same-origin',cache:'no-store',...options,signal:abort.signal});const body=await response.json();if(!response.ok)throw Object.assign(new Error(body.description||body.message||'request'),{status:response.status});return body;}finally{clearTimeout(timer);}}
function cartHasAttempt(cart,attempt){const entries=cart.items.filter(x=>x.properties?._sg_configuration===attempt.id);return attempt.items.every(p=>entries.filter(x=>String(x.variant_id)===String(p.id)).reduce((n,x)=>n+x.quantity,0)===p.quantity)&&entries.length===attempt.items.length;}
async function refreshSelection(){const rows=selectedProducts(state,products),ids=[...new Set(rows.map(p=>p.productId))],fresh=new Map();let changed=false,unavailable=false;for(let i=0;i<ids.length;i+=4){await Promise.all(ids.slice(i,i+4).map(async id=>{const product=products.find(p=>p.productId===id),data=await requestJSON(config.root+'products/'+encodeURIComponent(product.handle)+'.js');fresh.set(id,data);}));}for(const product of products){const data=fresh.get(product.productId);if(!data)continue;const v=data.variants.find(v=>String(v.id)===product.id);if(!v){if(state.items[product.id])unavailable=true;product.stock=false;continue;}if(!Number.isInteger(v.price)||v.price<0)throw new Error('invalid-price');const available=!!v.available;if(state.items[product.id]&&(!available||v.price!==product.price)){changed=true;if(!available)unavailable=true;}product.price=Number(v.price);product.stock=available;}return {changed,unavailable};}
async function addConfiguration(){
 if(cartBusy||cartLocked||!ready(9,state,products))return;
 if(config.designMode||!config.cartEnabled){cartMessage(t('preview_cart'));return;}
 cartBusy=true;render();let attempt=null;
 try{
  const current=await requestJSON(config.root+'cart.js');
  if(current.currency!==config.currency){cartMessage(t('currency_changed'));return;}
  const result=await refreshSelection();
  if(result.changed||result.unavailable){render();cartMessage(t(result.unavailable?'unavailable_changed':'price_changed'));return;}
  const id=globalThis.crypto?.randomUUID?.()||Date.now().toString(36)+'-'+Math.random().toString(36).slice(2);
  attempt={id,items:selectedProducts(state,products).map(p=>({id:p.id,quantity:p.quantity})),created:Date.now()};
  storePending(attempt);
  await requestJSON(config.root+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({items:attempt.items.map(p=>({...p,properties:{_sg_configuration:id}}))})});
  cartLocked=true;storePending(null);window.location.assign(config.cartUrl);
 }catch(error){
  if(attempt){
   try{const cart=await requestJSON(config.root+'cart.js');if(cartHasAttempt(cart,attempt)){cartLocked=true;storePending(null);window.location.assign(config.cartUrl);return;}
    const partial=cart.items.some(x=>x.properties?._sg_configuration===attempt.id);
    if(error.status&& !partial){storePending(null);cartMessage(t('cart_rejected'));}
    else{cartLocked=true;cartMessage(t(partial?'cart_partial':'cart_unknown'));}
   }catch{cartLocked=true;cartMessage(t('cart_unknown'));}
  }else cartMessage(t('check_failed'));
 }finally{cartBusy=false;render();}
}
async function recoverPending(){const attempt=readPending();if(!attempt?.id)return;cartLocked=true;render();try{const cart=await requestJSON(config.root+'cart.js');cartMessage(t(cartHasAttempt(cart,attempt)?'cart_already_added':'cart_unknown'));}catch{cartMessage(t('cart_unknown'));}}


const rules=JSON.parse($('[data-rules]').textContent),live=JSON.parse($('[data-products]').textContent);
const seen=new Set();
for(const p of live){for(const v of p.variants){const id=String(v.id),m=rules[id];if(!m||seen.has(id))continue;seen.add(id);products.push({...m,id,productId:String(p.id),title:p.title,brand:p.vendor,handle:p.handle,url:p.url,image:p.image,variant:v.title==='Default Title'?'':v.title==='Ohne'?t('without_upgrade'):v.title,price:Number(v.price),stock:!!v.available,maxQuantity:Math.max(1,Number(v.maximum)||99)});}}
function adjustOffsets(){const header=document.querySelector('.shopify-section-header, .section-header');const height=header?header.getBoundingClientRect().height:0;root.style.setProperty('--sg-top',height+'px');}
const resizeObserver=globalThis.ResizeObserver?new ResizeObserver(adjustOffsets):null;const header=document.querySelector('.shopify-section-header, .section-header');if(header)resizeObserver?.observe(header);adjustOffsets();
root._resume=()=>{if(header)resizeObserver?.observe(header);adjustOffsets();};root._cleanup=()=>{resizeObserver?.disconnect();clearTimeout(toastTimer);};
if(!products.length){$('[data-cart-message]').hidden=false;$('[data-cart-message]').textContent=t('no_products');}else{render();recoverPending();}

}
disconnectedCallback(){this._cleanup?.();}
}
if(!customElements.get('sg-set-configurator'))customElements.define('sg-set-configurator',SGSetConfigurator);


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sg-set-navigation"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('sg-set-navigation')) {
  customElements.define('sg-set-navigation', class extends HTMLElement {
    connectedCallback() {
      this.abort?.abort();
      this.abort = new AbortController();
      const signal = this.abort.signal;
      this.schedule = () => { if (!this.frame) this.frame = requestAnimationFrame(() => { this.frame = 0; this.update(); }); };
      this.init = () => {
        this.nav = this.querySelector('nav');
        if (!this.nav) return;
        this.header = document.querySelector('.section-header');
        this.main = document.getElementById('MainContent') || document.querySelector('main');
        this.contentBounds = [];
        this.links = [...this.querySelectorAll('a[data-target]')];
        this.resolve();
        this.nav.addEventListener('click', event => this.jump(event), { signal });
        window.addEventListener('scroll', this.schedule, { passive: true, signal });
        window.addEventListener('resize', this.schedule, { passive: true, signal });
        window.addEventListener('pageshow', this.schedule, { signal });
        document.addEventListener('shopify:section:load', () => { this.resolve(); this.schedule(); }, { signal });
        document.addEventListener('shopify:section:unload', this.schedule, { signal });
        this.resizeObserver = new ResizeObserver(this.schedule);
        if (this.header) this.resizeObserver.observe(this.header);
        if (this.main) this.resizeObserver.observe(this.main);
        this.resizeObserver.observe(this.nav);
        if (this.header) {
          this.headerObserver = new MutationObserver(() => { this.animateUntil = performance.now() + 200; this.schedule(); });
          this.headerObserver.observe(this.header, { attributes: true, attributeFilter: ['class'] });
        }
        this.schedule();
      };
      if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', this.init, { once: true, signal });
      else this.init();
    }
    resolve() {
      const overviewLink = this.links.find(link => link.dataset.kind === 'overview');
      this.productSection = overviewLink ? [...(this.main?.children || [])].find(el => el.id === overviewLink.dataset.target || el.id.endsWith('__' + overviewLink.dataset.target)) : null;
      this.entries = this.links.map(link => {
        let target = document.getElementById(link.dataset.target);
        if (link.dataset.kind === 'details') {
          const descriptionSection = [...(this.main?.children || [])].find(section => section.id.endsWith('__accordion_collapse_kXzB3j'));
          target = descriptionSection?.querySelector('h2, h3') || this.main?.querySelector('.product__description');
        }
        if (!target) target = [...(this.main?.children || [])].find(el => el.id.endsWith('__' + link.dataset.target));
        if (target && link.dataset.kind === 'overview') target = target.querySelector('h1') || target;
        else if (target && link.dataset.kind === 'reviews') target = target.querySelector('.jdgm-review-widget') || target;
        else if (target) target = target.querySelector('h2, h3') || target;
        link.hidden = !target;
        if (target) {
          if (!target.id) target.id = 'sg-set-' + link.dataset.kind;
          link.href = '#' + target.id;
        }
        return { link, target };
      }).filter(entry => entry.target);
      this.contentBounds = [...new Set(this.entries.filter(entry => entry.link.dataset.kind !== 'overview').map(entry => entry.target.closest('.product__description') || entry.target.closest('.page-width') || entry.target.closest('.shopify-section')).filter(element => element && element !== this.productSection))];
      for (const element of this.main.querySelectorAll('.page-width')) {
        if (!this.productSection?.contains(element) && !element.querySelector('.page-width') && !this.contentBounds.includes(element)) this.contentBounds.push(element);
      }
      for (const section of this.main.children) {
        if (section !== this.productSection && !section.contains(this) && section.querySelector('h2, h3') && !section.querySelector('.page-width') && !section.classList.contains('page-width') && !this.contentBounds.includes(section)) this.contentBounds.push(section);
      }
      for (const element of this.contentBounds) {
        if (!element.classList.contains('sg-section-nav-content')) element.style.setProperty('--sg-section-nav-padding', getComputedStyle(element).paddingLeft);
        element.classList.add('sg-section-nav-content');
      }
    }
    update() {
      if (!this.nav || !this.isConnected) return;
      const rect = this.header?.getBoundingClientRect();
      const offset = rect ? Math.max(0, Math.min(rect.bottom, rect.height)) : 0;
      this.style.setProperty('--sg-set-nav-top', Math.round(offset) + 'px');
      const detailsBesideGallery = this.entries.some(entry => entry.link.dataset.kind === 'details' && this.productSection?.contains(entry.target)) && this.productSection.getBoundingClientRect().bottom > offset;
      const side = innerWidth >= 990 && innerHeight >= 600 && !detailsBesideGallery;
      for (const element of this.contentBounds) {
        const inset = Math.max(0, 176 - element.getBoundingClientRect().left) + 'px';
        if (side && element.style.getPropertyValue('--sg-section-nav-inset') !== inset) element.style.setProperty('--sg-section-nav-inset', inset);
        else if (!side) element.style.removeProperty('--sg-section-nav-inset');
      }
      const contentLeft = 176;
      this.toggleAttribute('data-side', side);
      if (side) this.style.setProperty('--sg-set-nav-left', Math.floor(contentLeft - 148) + 'px');
      const usable = this.entries.filter(entry => entry.target.isConnected && entry.target.getClientRects().length && entry.target.getBoundingClientRect().height > 0);
      for (const entry of this.entries) entry.link.hidden = !usable.includes(entry);
      const desktop = window.innerWidth >= 990;
      const contentStart = Math.min(...usable.filter(entry => entry.link.dataset.kind !== 'overview').map(entry => entry.target.getBoundingClientRect().top));
      const revealEdge = offset + (side ? 0 : this.nav.offsetHeight) + 24;
      const productPassed = contentStart <= revealEdge || (this.productSection && this.productSection.getBoundingClientRect().bottom <= revealEdge);
      const visible = window.scrollY > Number(this.dataset.reveal || 500) && productPassed && usable.length > 1;
      this.toggleAttribute('data-visible', visible);
      this.nav.inert = !visible;
      const threshold = offset + (side ? 0 : this.nav.offsetHeight) + 24;
      let current = usable[0];
      for (const entry of usable) if (entry.target.getBoundingClientRect().top <= threshold) current = entry;
      for (const entry of usable) {
        if (entry === current) entry.link.setAttribute('aria-current', 'location');
        else entry.link.removeAttribute('aria-current');
      }
      if (current && current !== this.current && visible && !side) {
        const row = this.querySelector('.sg-set-navigation__links');
        if (!this.nav.contains(document.activeElement)) {
          const a = current.link.getBoundingClientRect();
          const r = row.getBoundingClientRect();
          if (a.left < r.left || a.right > r.right) row.scrollBy({ left: a.left - r.left - 12, behavior: 'instant' });
        }
      }
      this.current = current;
      if (performance.now() < (this.animateUntil || 0)) this.schedule();
    }
    jump(event) {
      const link = event.target.closest('a[data-target]');
      if (!link || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.button !== 0) return;
      const entry = this.entries.find(item => item.link === link);
      if (!entry?.target.isConnected) return;
      event.preventDefault();
      const headerRect = this.header?.getBoundingClientRect();
      const headerHeight = headerRect ? Math.max(0, Math.min(headerRect.bottom, headerRect.height)) : 0;
      const offset = headerHeight + (this.hasAttribute('data-side') ? 0 : this.nav.offsetHeight) + 16;
      entry.target.setAttribute('tabindex', '-1');
      entry.target.focus({ preventScroll: true });
      window.scrollTo({ top: Math.max(0, window.scrollY + entry.target.getBoundingClientRect().top - offset), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
    }
    disconnectedCallback() {
      for (const element of this.contentBounds || []) {
        element.classList.remove('sg-section-nav-content');
        element.style.removeProperty('--sg-section-nav-padding');
        element.style.removeProperty('--sg-section-nav-inset');
      }
      this.abort?.abort();
      this.resizeObserver?.disconnect();
      this.headerObserver?.disconnect();
      cancelAnimationFrame(this.frame);
      this.frame = 0;
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sg-size-product-grid"]) return;
  try {
    
if (!customElements.get('sg-size-grid')) {
  customElements.define('sg-size-grid', class extends HTMLElement {
    connectedCallback() {
      this.initTimer = setTimeout(() => this.init(), 0);
    }
    disconnectedCallback() {
      clearTimeout(this.initTimer);
      this.unmountFilterShell();
      this.abort?.abort();
      this.fetchAbort?.abort();
      this.chipObservers?.forEach(observer => observer.disconnect());
      if (this.onHash) window.removeEventListener('hashchange', this.onHash);
    }
    init() {
      if (this.ready || !this.isConnected) return;
      this.controls = this.querySelector('.sg-size-controls');
      this.grid = this.querySelector('ul#product-grid');
      if (!this.controls || !this.grid) return;
      this.ready = true;
      this.sizeSelect = this.querySelector('[data-sg-size]');
      this.appSelect = this.querySelector('[data-sg-app-select]');
      this.wattSelect = this.querySelector('[data-sg-watt-select]');
      this.planningToggle = this.querySelector('[data-sg-include-planning]');
      this.sortSelect = this.querySelector('[data-sg-sort]');
      this.status = this.querySelector('[data-sg-status]');
      this.pagination = this.querySelector('[data-sg-pagination]');
      this.original = [...this.grid.children];
      this.cache = new Map();
      this.pendingCards = new Map();
      this.fetchAbort = new AbortController();
      this.sequence = 0;
      this.applied = { size: '', app: '', watt: '', planning: true, sort: this.dataset.sort };
      this.controls.addEventListener('change', () => this.apply());
      this.querySelector('[data-sg-reset]').addEventListener('click', () => {
        this.sizeSelect.value = '';
        if (this.appSelect) this.appSelect.value = '';
        if (this.wattSelect) this.wattSelect.value = '';
        if (this.planningToggle) this.planningToggle.checked = true;
        this.apply();
      });
      this.controls.hidden = false;
      this.mountChips();
      this.mountFilterShell();
      this.classList.add('sg-filter-ready');
      this.onHash = () => {
        const params = new URLSearchParams(location.hash.slice(1));
        const size = params.get('sg-size');
        const watt = params.get('sg-watt');
        const validSize = size && [...this.sizeSelect.options].some(option => option.value === size);
        const validWatt = watt && this.wattSelect && [...this.wattSelect.options].some(option => option.value === watt);
        if (!validSize && !validWatt) return;
        this.sizeSelect.value = validSize ? size : '';
        if (this.wattSelect) this.wattSelect.value = validWatt ? watt : '';
        if (this.appSelect) this.appSelect.value = '';
        this.apply();
        const cleanURL = new URL(location.href);
        cleanURL.hash = '';
        history.replaceState(history.state, '', cleanURL);
        this.querySelector('.product-grid-container').scrollIntoView({ block: 'start', behavior: 'auto' });
      };
      window.addEventListener('hashchange', this.onHash);
      this.onHash();
    }

    captureFilterView() {
      const rect = this.grid.getBoundingClientRect();
      const header = document.querySelector('.section-header')?.getBoundingClientRect();
      const top = Math.max(0, header?.bottom || 0);
      return { x: window.scrollX, y: window.scrollY, gridTop: rect.top + window.scrollY, inGrid: rect.bottom > top && rect.top < window.innerHeight };
    }
    restoreFilterView(view, changed = true) {
      if (!view) return;
      let y = view.y;
      if (changed && view.inGrid) {
        const rect = this.grid.getBoundingClientRect();
        const gridTop = rect.top + window.scrollY;
        const header = document.querySelector('.section-header')?.getBoundingClientRect();
        const offset = Math.max(0, header?.bottom || 0) + 16;
        const lastResult = [...this.grid.children].reverse().find(card => !card.hidden);
        const lastTop = lastResult ? lastResult.getBoundingClientRect().top + window.scrollY : gridTop;
        y = Math.min(view.y + gridTop - view.gridTop, Math.max(0, lastTop - offset));
      }
      window.scrollTo({ left: view.x, top: Math.max(0, y), behavior: 'instant' });
    }
    unlockFilterDialog() {
      if (!this.filterLock) return;
      const lock = this.filterLock;
      this.filterLock = null;
      for (const [name, value, priority] of lock.styles) {
        if (value) document.body.style.setProperty(name, value, priority);
        else document.body.style.removeProperty(name);
      }
      this.filterButton.setAttribute('aria-expanded', 'false');
      if (this.filterButton.isConnected && !this.filterMedia.matches) this.filterButton.focus({ preventScroll: true });
      this.restoreFilterView(lock.view, lock.changed);
    }

    mountFilterShell() {
      this.classList.add('sg-filter-shell');
      this.filterMedia = matchMedia('(min-width: 990px)');
      this.filterAnchor = document.createComment('');
      this.controls.before(this.filterAnchor);
      const title = document.createElement('p');
      title.className = 'sg-filter-heading';
      title.textContent = this.controls.dataset.filterTitle;
      this.controls.prepend(title);
      this.filterLauncher = document.createElement('div');
      this.filterLauncher.className = 'sg-filter-launcher';
      this.filterButton = document.createElement('button');
      this.filterButton.type = 'button';
      this.filterButton.textContent = this.controls.dataset.filterTitle;
      this.filterButton.setAttribute('aria-haspopup', 'dialog');
      this.filterButton.setAttribute('aria-expanded', 'false');
      this.filterLauncher.append(this.filterButton);
      this.filterAnchor.before(this.filterLauncher);
      this.filterDialog = document.createElement('dialog');
      this.filterDialog.className = 'sg-filter-dialog';
      this.filterDialog.id = 'sg-filter-dialog-' + this.dataset.section;
      this.filterButton.setAttribute('aria-controls', this.filterDialog.id);
      this.filterDialog.setAttribute('aria-label', this.controls.dataset.filterTitle);
      const bar = document.createElement('div');
      bar.className = 'sg-filter-dialog__bar';
      const heading = title.cloneNode(true);
      const close = document.createElement('button');
      close.type = 'button';
      close.className = 'sg-filter-close';
      close.textContent = '×';
      close.setAttribute('aria-label', this.controls.dataset.close);
      bar.append(heading, close);
      this.filterDone = document.createElement('button');
      this.filterDone.type = 'button';
      this.filterDone.className = 'sg-filter-done';
      this.filterDone.textContent = this.controls.dataset.show;
      this.filterDialog.append(bar, this.filterDone);
      this.append(this.filterDialog);
      this.filterButton.addEventListener('click', () => {
        if (this.filterDialog.open) return;
        const view = this.captureFilterView();
        const names = ['position', 'top', 'left', 'width', 'overflow', 'padding-right'];
        const styles = names.map(name => [name, document.body.style.getPropertyValue(name), document.body.style.getPropertyPriority(name)]);
        const gap = window.innerWidth - document.documentElement.clientWidth;
        const padding = parseFloat(getComputedStyle(document.body).paddingRight) || 0;
        this.filterLock = { view, styles, changed: false };
        document.body.style.position = 'fixed';
        document.body.style.top = -view.y + 'px';
        document.body.style.left = -view.x + 'px';
        document.body.style.width = '100%';
        document.body.style.overflow = 'hidden';
        if (gap > 0) document.body.style.paddingRight = padding + gap + 'px';
        this.filterDialog.showModal();
        this.filterButton.setAttribute('aria-expanded', 'true');
      });
      const restore = () => this.unlockFilterDialog();
      this.filterDialog.addEventListener('close', restore);
      close.addEventListener('click', () => this.filterDialog.close());
      this.filterDone.addEventListener('click', () => this.filterDialog.close());
      this.filterDialog.addEventListener('click', event => {
        if (event.target !== this.filterDialog) return;
        const rect = this.filterDialog.getBoundingClientRect();
        if (event.clientY < rect.top || event.clientX < rect.left || event.clientX > rect.right) this.filterDialog.close();
      });
      this.filterMode = () => {
        if (this.filterDialog.open) { this.filterDialog.close(); restore(); }
        if (this.filterMedia.matches) this.filterAnchor.after(this.controls);
        else this.filterDone.before(this.controls);
      };
      this.filterMedia.addEventListener('change', this.filterMode);
      this.filterMode();
      this.filterVisibility = new IntersectionObserver(entries => {
        this.classList.toggle('sg-filter-in-view', entries[0].isIntersecting);
      });
      this.filterVisibility.observe(this.querySelector('.product-grid-container'));
      const header = document.querySelector('.section-header');
      if (header) {
        this.filterHeaderObserver = new ResizeObserver(() => {
          this.style.setProperty('--sg-filter-top', (header.getBoundingClientRect().height + 16) + 'px');
        });
        this.filterHeaderObserver.observe(header);
      }
    }
    unmountFilterShell() {
      this.filterVisibility?.disconnect();
      this.filterHeaderObserver?.disconnect();
      this.filterMedia?.removeEventListener('change', this.filterMode);
      if (this.filterDialog?.open) {
        this.filterDialog.close();
        this.unlockFilterDialog();
      }
    }

    mountChips() {
      this.chipGroups = [];
      this.chipObservers = [];
      this.controls.querySelectorAll('select:not([data-sg-sort])').forEach(select => {
        const label = select.closest('label');
        const title = [...label.childNodes].filter(node => node.nodeType === Node.TEXT_NODE).map(node => node.textContent).join('').trim();
        const group = document.createElement('fieldset');
        group.className = 'sg-chip-group';
        const legend = document.createElement('legend');
        legend.textContent = title;
        const track = document.createElement('div');
        track.className = 'sg-chip-track';
        const cue = document.createElement('span');
        cue.className = 'sg-chip-cue';
        cue.textContent = this.controls.dataset.swipe;
        const buttons = [...select.options].map(option => {
          const button = document.createElement('button');
          button.type = 'button';
          button.className = 'sg-chip';
          button.textContent = option.textContent;
          button.dataset.value = option.value;
          button.addEventListener('click', () => {
            select.value = select.value === option.value ? '' : option.value;
            select.dispatchEvent(new Event('change', { bubbles: true }));
          });
          track.append(button);
          return button;
        });
        group.append(legend, track, cue);
        label.before(group);
        label.hidden = true;
        this.chipGroups.push({ select, buttons, title });
        const updateCue = () => { cue.hidden = track.scrollWidth <= track.clientWidth + 2; };
        const observer = new ResizeObserver(updateCue);
        observer.observe(track);
        this.chipObservers.push(observer);
      });
      this.sortSelect.closest('label').classList.add('sg-chip-sort');
      this.activeSummary = document.createElement('div');
      this.activeSummary.className = 'sg-chip-active';
      this.activeSummary.setAttribute('aria-label', this.controls.dataset.active);
      this.controls.querySelector('.sg-size-fields').after(this.activeSummary);
      this.syncChips();
    }
    syncChips() {
      if (!this.chipGroups) return;
      this.activeSummary.replaceChildren();
      this.chipGroups.forEach(({ select, buttons, title }) => {
        const options = [...select.options];
        buttons.forEach(button => {
          button.hidden = !options.some(option => option.value === button.dataset.value);
          button.setAttribute('aria-pressed', String(select.value === button.dataset.value));
        });
        if (select.value) {
          const remove = document.createElement('button');
          remove.type = 'button';
          const value = select.selectedOptions[0].textContent;
          remove.textContent = value + ' ×';
          remove.setAttribute('aria-label', this.controls.dataset.remove + ' ' + title + ' ' + value);
          remove.addEventListener('click', () => {
            select.value = '';
            select.dispatchEvent(new Event('change', { bubbles: true }));
            buttons[0]?.focus();
          });
          this.activeSummary.append(remove);
        }
      });
      this.activeSummary.hidden = this.activeSummary.childElementCount === 0;
      this.querySelector('[data-sg-reset]').disabled = this.activeSummary.hidden;
    }

    async allCards(sort) {
      if (this.cache.has(sort)) return this.cache.get(sort);
      if (this.pendingCards.has(sort)) return this.pendingCards.get(sort);
      const pending = this.loadCards(sort, this.fetchAbort.signal);
      this.pendingCards.set(sort, pending);
      try { return await pending; }
      finally { if (this.pendingCards.get(sort) === pending) this.pendingCards.delete(sort); }
    }
    async loadCards(sort, signal) {
      const pages = Number(this.dataset.pages);
      const result = new Array(pages);
      const url = new URL(location.href);
      url.searchParams.set('section_id', this.dataset.section);
      url.searchParams.set('sort_by', sort);
      const indices = Array.from({ length: pages }, (_, i) => i);
      for (let start = 0; start < pages; start += 4) {
        await Promise.all(indices.slice(start, start + 4).map(async index => {
          if (index + 1 === Number(this.dataset.page) && sort === this.dataset.sort) {
            result[index] = this.original;
            return;
          }
          const pageURL = new URL(url);
          pageURL.searchParams.set('page', String(index + 1));
          const response = await fetch(pageURL, { signal, credentials: 'same-origin' });
          if (!response.ok) throw new Error('Section request failed');
          const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
          const section = [...doc.querySelectorAll('sg-size-grid')].find(el => el.dataset.section === this.dataset.section);
          if (!section || Number(section.dataset.count) !== Number(this.dataset.count)) throw new Error('Collection changed');
          const cards = [...section.querySelectorAll('ul#product-grid > li')];
          if (!cards.length) throw new Error('Missing cards');
          cards.forEach(card => {
            card.querySelectorAll('.scroll-trigger').forEach(el => el.classList.add('scroll-trigger--cancel'));
            card.classList.add('scroll-trigger--cancel');
          });
          result[index] = cards;
        }));
      }
      const cards = result.flat();
      const unique = new Set(cards.map(card => card.dataset.sgProductId));
      if (cards.length !== Number(this.dataset.count) || unique.size !== cards.length || unique.has(undefined)) throw new Error('Incomplete collection');
      this.cache.set(sort, cards);
      return cards;
    }
    async apply() {
      const sequence = ++this.sequence;
      this.abort?.abort();
      this.abort = new AbortController();
      const next = { size: this.sizeSelect.value, app: this.appSelect?.value || '', watt: this.wattSelect?.value || '', planning: this.planningToggle?.checked ?? false, sort: this.sortSelect.value };
      this.syncChips();
      this.status.textContent = this.status.dataset.loading;
      this.grid.setAttribute('aria-busy', 'true');
      try {
        const cards = await this.allCards(next.sort, this.abort.signal);
        if (sequence !== this.sequence || !this.isConnected) return;
        const view = this.filterLock ? null : this.captureFilterView();
        let count = 0;
        cards.forEach(card => {
          const sizes = (card.dataset.sgSizes || '').split(' ').filter(Boolean);
          const needsPlanning = this.dataset.collection === 'led-beleuchtung' && sizes.length === 0;
          const sizeMatches = !next.size || (next.size === 'planning' ? needsPlanning : sizes.includes(next.size) || (needsPlanning && next.planning));
          card.hidden = Boolean(!sizeMatches || (next.app && (card.dataset.sgApp || 'unknown') !== next.app) || (next.watt && card.dataset.sgWatt !== next.watt));
          if (!card.hidden) count++;
        });
        this.grid.replaceChildren(...cards);
        this.pagination.hidden = true;
        this.status.textContent = this.status.dataset.countText.replace('{count}', String(count));
        this.applied = next;
        if (this.filterLock) this.filterLock.changed = true;
        else this.restoreFilterView(view);
      } catch (error) {
        if (sequence !== this.sequence || error.name === 'AbortError' || !this.isConnected) return;
        this.sizeSelect.value = this.applied.size;
        if (this.appSelect) this.appSelect.value = this.applied.app;
        this.sortSelect.value = this.applied.sort;
        if (this.wattSelect) this.wattSelect.value = this.applied.watt;
        if (this.planningToggle) this.planningToggle.checked = this.applied.planning;
        this.status.textContent = this.status.dataset.error;
      } finally {
        if (sequence === this.sequence) { this.grid.removeAttribute('aria-busy'); this.syncChips(); }
      }
    }
  });
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sg-type-product-grid"]) return;
  try {
    
if (!customElements.get('sg-type-grid')) {
  customElements.define('sg-type-grid', class extends HTMLElement {
    connectedCallback() {
      this.initTimer = setTimeout(() => this.init(), 0);
    }
    disconnectedCallback() {
      clearTimeout(this.initTimer);
      this.unmountFilterShell();
      this.abort?.abort();
      this.fetchAbort?.abort();
      this.chipObservers?.forEach(observer => observer.disconnect());
      if (this.onHash) window.removeEventListener('hashchange', this.onHash);
    }
    init() {
      if (this.ready || !this.isConnected) return;
      this.controls = this.querySelector('.sg-size-controls');
      this.grid = this.querySelector('ul#product-grid');
      if (!this.controls || !this.grid) return;
      this.ready = true;
      this.sizeSelect = this.querySelector('[data-sg-size]');
      this.appSelect = this.querySelector('[data-sg-app-select]');
      this.sortSelect = this.querySelector('[data-sg-sort]');
      this.status = this.querySelector('[data-sg-status]');
      this.pagination = this.querySelector('[data-sg-pagination]');
      this.original = [...this.grid.children];
      this.cache = new Map();
      this.pendingCards = new Map();
      this.fetchAbort = new AbortController();
      this.sequence = 0;
      this.applied = { size: '', app: '', sort: this.dataset.sort };
      this.controls.addEventListener('change', () => this.apply());
      this.querySelector('[data-sg-reset]').addEventListener('click', () => {
        this.sizeSelect.value = '';
        if (this.appSelect) this.appSelect.value = '';
        this.apply();
      });
      this.controls.hidden = false;
      this.mountChips();
      this.mountFilterShell();
      this.classList.add('sg-filter-ready');
      this.pruneOptions();

    }
    async pruneOptions() {
      try {
        const cards = await this.allCards(this.dataset.sort);
        if (!this.isConnected || this.sequence > 0) return;
        const present = new Set(cards.flatMap(card => (card.dataset.sgSizes || '').split(' ')));
        [...this.sizeSelect.options].forEach(option => {
          if (option.value && !present.has(option.value)) option.remove();
        });
        this.syncChips();
      } catch (_) {}
    }

    captureFilterView() {
      const rect = this.grid.getBoundingClientRect();
      const header = document.querySelector('.section-header')?.getBoundingClientRect();
      const top = Math.max(0, header?.bottom || 0);
      return { x: window.scrollX, y: window.scrollY, gridTop: rect.top + window.scrollY, inGrid: rect.bottom > top && rect.top < window.innerHeight };
    }
    restoreFilterView(view, changed = true) {
      if (!view) return;
      let y = view.y;
      if (changed && view.inGrid) {
        const rect = this.grid.getBoundingClientRect();
        const gridTop = rect.top + window.scrollY;
        const header = document.querySelector('.section-header')?.getBoundingClientRect();
        const offset = Math.max(0, header?.bottom || 0) + 16;
        const lastResult = [...this.grid.children].reverse().find(card => !card.hidden);
        const lastTop = lastResult ? lastResult.getBoundingClientRect().top + window.scrollY : gridTop;
        y = Math.min(view.y + gridTop - view.gridTop, Math.max(0, lastTop - offset));
      }
      window.scrollTo({ left: view.x, top: Math.max(0, y), behavior: 'instant' });
    }
    unlockFilterDialog() {
      if (!this.filterLock) return;
      const lock = this.filterLock;
      this.filterLock = null;
      for (const [name, value, priority] of lock.styles) {
        if (value) document.body.style.setProperty(name, value, priority);
        else document.body.style.removeProperty(name);
      }
      this.filterButton.setAttribute('aria-expanded', 'false');
      if (this.filterButton.isConnected && !this.filterMedia.matches) this.filterButton.focus({ preventScroll: true });
      this.restoreFilterView(lock.view, lock.changed);
    }

    mountFilterShell() {
      this.classList.add('sg-filter-shell');
      this.filterMedia = matchMedia('(min-width: 990px)');
      this.filterAnchor = document.createComment('');
      this.controls.before(this.filterAnchor);
      const title = document.createElement('p');
      title.className = 'sg-filter-heading';
      title.textContent = this.controls.dataset.filterTitle;
      this.controls.prepend(title);
      this.filterLauncher = document.createElement('div');
      this.filterLauncher.className = 'sg-filter-launcher';
      this.filterButton = document.createElement('button');
      this.filterButton.type = 'button';
      this.filterButton.textContent = this.controls.dataset.filterTitle;
      this.filterButton.setAttribute('aria-haspopup', 'dialog');
      this.filterButton.setAttribute('aria-expanded', 'false');
      this.filterLauncher.append(this.filterButton);
      this.filterAnchor.before(this.filterLauncher);
      this.filterDialog = document.createElement('dialog');
      this.filterDialog.className = 'sg-filter-dialog';
      this.filterDialog.id = 'sg-filter-dialog-' + this.dataset.section;
      this.filterButton.setAttribute('aria-controls', this.filterDialog.id);
      this.filterDialog.setAttribute('aria-label', this.controls.dataset.filterTitle);
      const bar = document.createElement('div');
      bar.className = 'sg-filter-dialog__bar';
      const heading = title.cloneNode(true);
      const close = document.createElement('button');
      close.type = 'button';
      close.className = 'sg-filter-close';
      close.textContent = '×';
      close.setAttribute('aria-label', this.controls.dataset.close);
      bar.append(heading, close);
      this.filterDone = document.createElement('button');
      this.filterDone.type = 'button';
      this.filterDone.className = 'sg-filter-done';
      this.filterDone.textContent = this.controls.dataset.show;
      this.filterDialog.append(bar, this.filterDone);
      this.append(this.filterDialog);
      this.filterButton.addEventListener('click', () => {
        if (this.filterDialog.open) return;
        const view = this.captureFilterView();
        const names = ['position', 'top', 'left', 'width', 'overflow', 'padding-right'];
        const styles = names.map(name => [name, document.body.style.getPropertyValue(name), document.body.style.getPropertyPriority(name)]);
        const gap = window.innerWidth - document.documentElement.clientWidth;
        const padding = parseFloat(getComputedStyle(document.body).paddingRight) || 0;
        this.filterLock = { view, styles, changed: false };
        document.body.style.position = 'fixed';
        document.body.style.top = -view.y + 'px';
        document.body.style.left = -view.x + 'px';
        document.body.style.width = '100%';
        document.body.style.overflow = 'hidden';
        if (gap > 0) document.body.style.paddingRight = padding + gap + 'px';
        this.filterDialog.showModal();
        this.filterButton.setAttribute('aria-expanded', 'true');
      });
      const restore = () => this.unlockFilterDialog();
      this.filterDialog.addEventListener('close', restore);
      close.addEventListener('click', () => this.filterDialog.close());
      this.filterDone.addEventListener('click', () => this.filterDialog.close());
      this.filterDialog.addEventListener('click', event => {
        if (event.target !== this.filterDialog) return;
        const rect = this.filterDialog.getBoundingClientRect();
        if (event.clientY < rect.top || event.clientX < rect.left || event.clientX > rect.right) this.filterDialog.close();
      });
      this.filterMode = () => {
        if (this.filterDialog.open) { this.filterDialog.close(); restore(); }
        if (this.filterMedia.matches) this.filterAnchor.after(this.controls);
        else this.filterDone.before(this.controls);
      };
      this.filterMedia.addEventListener('change', this.filterMode);
      this.filterMode();
      this.filterVisibility = new IntersectionObserver(entries => {
        this.classList.toggle('sg-filter-in-view', entries[0].isIntersecting);
      });
      this.filterVisibility.observe(this.querySelector('.product-grid-container'));
      const header = document.querySelector('.section-header');
      if (header) {
        this.filterHeaderObserver = new ResizeObserver(() => {
          this.style.setProperty('--sg-filter-top', (header.getBoundingClientRect().height + 16) + 'px');
        });
        this.filterHeaderObserver.observe(header);
      }
    }
    unmountFilterShell() {
      this.filterVisibility?.disconnect();
      this.filterHeaderObserver?.disconnect();
      this.filterMedia?.removeEventListener('change', this.filterMode);
      if (this.filterDialog?.open) {
        this.filterDialog.close();
        this.unlockFilterDialog();
      }
    }

    mountChips() {
      this.chipGroups = [];
      this.chipObservers = [];
      this.controls.querySelectorAll('select:not([data-sg-sort])').forEach(select => {
        const label = select.closest('label');
        const title = [...label.childNodes].filter(node => node.nodeType === Node.TEXT_NODE).map(node => node.textContent).join('').trim();
        const group = document.createElement('fieldset');
        group.className = 'sg-chip-group';
        const legend = document.createElement('legend');
        legend.textContent = title;
        const track = document.createElement('div');
        track.className = 'sg-chip-track';
        const cue = document.createElement('span');
        cue.className = 'sg-chip-cue';
        cue.textContent = this.controls.dataset.swipe;
        const buttons = [...select.options].map(option => {
          const button = document.createElement('button');
          button.type = 'button';
          button.className = 'sg-chip';
          button.textContent = option.textContent;
          button.dataset.value = option.value;
          button.addEventListener('click', () => {
            select.value = select.value === option.value ? '' : option.value;
            select.dispatchEvent(new Event('change', { bubbles: true }));
          });
          track.append(button);
          return button;
        });
        group.append(legend, track, cue);
        label.before(group);
        label.hidden = true;
        this.chipGroups.push({ select, buttons, title });
        const updateCue = () => { cue.hidden = track.scrollWidth <= track.clientWidth + 2; };
        const observer = new ResizeObserver(updateCue);
        observer.observe(track);
        this.chipObservers.push(observer);
      });
      this.sortSelect.closest('label').classList.add('sg-chip-sort');
      this.activeSummary = document.createElement('div');
      this.activeSummary.className = 'sg-chip-active';
      this.activeSummary.setAttribute('aria-label', this.controls.dataset.active);
      this.controls.querySelector('.sg-size-fields').after(this.activeSummary);
      this.syncChips();
    }
    syncChips() {
      if (!this.chipGroups) return;
      this.activeSummary.replaceChildren();
      this.chipGroups.forEach(({ select, buttons, title }) => {
        const options = [...select.options];
        buttons.forEach(button => {
          button.hidden = !options.some(option => option.value === button.dataset.value);
          button.setAttribute('aria-pressed', String(select.value === button.dataset.value));
        });
        if (select.value) {
          const remove = document.createElement('button');
          remove.type = 'button';
          const value = select.selectedOptions[0].textContent;
          remove.textContent = value + ' ×';
          remove.setAttribute('aria-label', this.controls.dataset.remove + ' ' + title + ' ' + value);
          remove.addEventListener('click', () => {
            select.value = '';
            select.dispatchEvent(new Event('change', { bubbles: true }));
            buttons[0]?.focus();
          });
          this.activeSummary.append(remove);
        }
      });
      this.activeSummary.hidden = this.activeSummary.childElementCount === 0;
      this.querySelector('[data-sg-reset]').disabled = this.activeSummary.hidden;
    }

    async allCards(sort) {
      if (this.cache.has(sort)) return this.cache.get(sort);
      if (this.pendingCards.has(sort)) return this.pendingCards.get(sort);
      const pending = this.loadCards(sort, this.fetchAbort.signal);
      this.pendingCards.set(sort, pending);
      try { return await pending; }
      finally { if (this.pendingCards.get(sort) === pending) this.pendingCards.delete(sort); }
    }
    async loadCards(sort, signal) {
      const pages = Number(this.dataset.pages);
      const result = new Array(pages);
      const url = new URL(location.href);
      url.searchParams.set('section_id', this.dataset.section);
      url.searchParams.set('sort_by', sort);
      const indices = Array.from({ length: pages }, (_, i) => i);
      for (let start = 0; start < pages; start += 4) {
        await Promise.all(indices.slice(start, start + 4).map(async index => {
          if (index + 1 === Number(this.dataset.page) && sort === this.dataset.sort) {
            result[index] = this.original;
            return;
          }
          const pageURL = new URL(url);
          pageURL.searchParams.set('page', String(index + 1));
          const response = await fetch(pageURL, { signal, credentials: 'same-origin' });
          if (!response.ok) throw new Error('Section request failed');
          const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
          const section = [...doc.querySelectorAll('sg-type-grid')].find(el => el.dataset.section === this.dataset.section);
          if (!section || Number(section.dataset.count) !== Number(this.dataset.count)) throw new Error('Collection changed');
          const cards = [...section.querySelectorAll('ul#product-grid > li')];
          if (!cards.length) throw new Error('Missing cards');
          cards.forEach(card => {
            card.querySelectorAll('.scroll-trigger').forEach(el => el.classList.add('scroll-trigger--cancel'));
            card.classList.add('scroll-trigger--cancel');
          });
          result[index] = cards;
        }));
      }
      const cards = result.flat();
      const unique = new Set(cards.map(card => card.dataset.sgProductId));
      if (cards.length !== Number(this.dataset.count) || unique.size !== cards.length || unique.has(undefined)) throw new Error('Incomplete collection');
      this.cache.set(sort, cards);
      return cards;
    }
    async apply() {
      const sequence = ++this.sequence;
      this.abort?.abort();
      this.abort = new AbortController();
      const next = { size: this.sizeSelect.value, app: this.appSelect?.value || '', sort: this.sortSelect.value };
      this.syncChips();
      this.status.textContent = this.status.dataset.loading;
      this.grid.setAttribute('aria-busy', 'true');
      try {
        const cards = await this.allCards(next.sort, this.abort.signal);
        if (sequence !== this.sequence || !this.isConnected) return;
        const view = this.filterLock ? null : this.captureFilterView();
        let count = 0;
        cards.forEach(card => {
          const sizes = (card.dataset.sgSizes || '').split(' ');
          card.hidden = Boolean((next.size && !sizes.includes(next.size)) || (next.app && card.dataset.sgApp !== next.app));
          if (!card.hidden) count++;
        });
        this.grid.replaceChildren(...cards);
        this.pagination.hidden = true;
        this.status.textContent = this.status.dataset.countText.replace('{count}', String(count));
        this.applied = next;
        if (this.filterLock) this.filterLock.changed = true;
        else this.restoreFilterView(view);
      } catch (error) {
        if (sequence !== this.sequence || error.name === 'AbortError' || !this.isConnected) return;
        this.sizeSelect.value = this.applied.size;
        if (this.appSelect) this.appSelect.value = this.applied.app;
        this.sortSelect.value = this.applied.sort;
        this.status.textContent = this.status.dataset.error;
      } finally {
        if (sequence === this.sequence) { this.grid.removeAttribute('aria-busy'); this.syncChips(); }
      }
    }
  });
}


  } catch(e) { console.error(e); }
})();
})();
